// import React, { useState, useRef } from 'react';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import './resumebuilder.css';

// function ResumeBuilder1() {
//   // Main states for the application
//   const [activeTab, setActiveTab] = useState('generator'); // 'generator' or 'atsChecker'
//   const [jobTitle, setJobTitle] = useState('');
//   const [jobDescription, setJobDescription] = useState('');
//   const [generatedResume, setGeneratedResume] = useState(null);
//   const [isGenerating, setIsGenerating] = useState(false);
//   const [atsScore, setAtsScore] = useState(null);
//   const [uploadedResume, setUploadedResume] = useState('');
//   const [atsJobDescription, setAtsJobDescription] = useState('');

//   // Refs
//   const resumeRef = useRef(null);

//   // Sample user data (in a real app, this would come from user input)
//   const [userData, setUserData] = useState({
//     name: 'John Smith',
//     email: 'johnsmith@email.com',
//     phone: '(555) 123-4567',
//     github: 'github.com/johnsmith',
//     linkedin: 'linkedin.com/in/johnsmith',
//     portfolio: 'johnsmith.dev',
//     education: 'Bachelor of Computer Science, University of Technology (2018-2022)'
//   });

//   // Job templates for different roles
//   const jobTemplates = {
//     'Software Developer': {
//       summary: 'Dedicated software developer with experience in building responsive web applications using modern frameworks and libraries. Strong problem-solving skills and ability to work in agile environments.',
//       skills: ['JavaScript', 'React', 'Node.js', 'CSS', 'HTML5', 'Git', 'REST APIs', 'MongoDB'],
//       experience: [
//         {
//           title: 'Software Developer',
//           company: 'Tech Solutions Inc.',
//           duration: 'Jan 2022 - Present',
//           responsibilities: [
//             'Developed and maintained multiple web applications using React and Node.js',
//             'Collaborated with design team to implement responsive UI components',
//             'Optimized application performance, reducing load time by 30%',
//             'Participated in code reviews and implemented feedback from senior developers'
//           ]
//         },
//         {
//           title: 'Junior Developer',
//           company: 'WebDev Studio',
//           duration: 'May 2020 - Dec 2021',
//           responsibilities: [
//             'Assisted in front-end development using HTML, CSS, and JavaScript',
//             'Fixed bugs and implemented new features for existing applications',
//             'Participated in daily stand-ups and sprint planning meetings'
//           ]
//         }
//       ],
//       projects: [
//         {
//           name: 'E-commerce Platform',
//           description: 'Built a full-stack e-commerce platform with user authentication, product catalog, and payment integration',
//           technologies: 'React, Node.js, Express, MongoDB, Stripe API'
//         },
//         {
//           name: 'Task Management Application',
//           description: 'Developed a collaborative task management tool with real-time updates',
//           technologies: 'React, Firebase, Material-UI'
//         }
//       ],
//       certifications: [
//         'AWS Certified Developer Associate',
//         'MongoDB Certified Developer'
//       ]
//     },
//     'Data Analyst': {
//       summary: 'Detail-oriented data analyst with expertise in extracting insights from complex datasets. Proficient in data visualization, statistical analysis, and communicating findings to stakeholders.',
//       skills: ['SQL', 'Python', 'R', 'Excel', 'Tableau', 'Power BI', 'Statistical Analysis', 'Data Visualization'],
//       experience: [
//         {
//           title: 'Data Analyst',
//           company: 'Data Insights Corp.',
//           duration: 'Mar 2021 - Present',
//           responsibilities: [
//             'Analyzed large datasets to identify trends and patterns for business decision making',
//             'Created interactive dashboards using Tableau to visualize key metrics',
//             'Developed automated reporting systems, saving 15 hours of manual work weekly',
//             'Collaborated with cross-functional teams to determine data collection needs'
//           ]
//         },
//         {
//           title: 'Business Intelligence Intern',
//           company: 'Analytics Solutions',
//           duration: 'Jun 2020 - Feb 2021',
//           responsibilities: [
//             'Assisted in data cleaning and preparation for analysis',
//             'Created reports using SQL and Excel for monthly business reviews',
//             'Helped maintain data quality in company databases'
//           ]
//         }
//       ],
//       projects: [
//         {
//           name: 'Customer Segmentation Analysis',
//           description: 'Conducted cluster analysis to identify distinct customer segments for targeted marketing',
//           technologies: 'Python, scikit-learn, Pandas, Matplotlib'
//         },
//         {
//           name: 'Sales Forecasting Model',
//           description: 'Developed a predictive model for quarterly sales forecasting with 92% accuracy',
//           technologies: 'R, Time Series Analysis, ggplot2'
//         }
//       ],
//       certifications: [
//         'Microsoft Certified: Data Analyst Associate',
//         'Google Data Analytics Professional Certificate'
//       ]
//     },
//     'Cloud Architect': {
//       summary: 'Experienced cloud architect specializing in designing scalable, secure, and efficient cloud infrastructure solutions. Skilled in multi-cloud environments with focus on cost optimization and performance.',
//       skills: ['AWS', 'Azure', 'GCP', 'Terraform', 'Docker', 'Kubernetes', 'CI/CD', 'Microservices', 'Security Best Practices'],
//       experience: [
//         {
//           title: 'Senior Cloud Architect',
//           company: 'CloudSolutions Inc.',
//           duration: 'Apr 2020 - Present',
//           responsibilities: [
//             'Designed and implemented cloud infrastructure for enterprise applications serving 1M+ users',
//             'Led migration of legacy systems to cloud-native architecture, reducing operational costs by 40%',
//             'Implemented Infrastructure as Code practices using Terraform and AWS CloudFormation',
//             'Established security best practices and compliance frameworks for cloud environments'
//           ]
//         },
//         {
//           title: 'Cloud Solutions Engineer',
//           company: 'TechCloud Services',
//           duration: 'Jan 2018 - Mar 2020',
//           responsibilities: [
//             'Deployed and managed AWS and Azure resources for client applications',
//             'Implemented automation for infrastructure provisioning and management',
//             'Provided technical support for cloud-based applications'
//           ]
//         }
//       ],
//       projects: [
//         {
//           name: 'Enterprise Multi-Cloud Strategy',
//           description: 'Designed hybrid cloud architecture leveraging AWS and Azure services with seamless integration',
//           technologies: 'AWS, Azure, Terraform, Kubernetes'
//         },
//         {
//           name: 'Serverless Application Platform',
//           description: 'Built a scalable serverless platform handling millions of events daily with automated scaling',
//           technologies: 'AWS Lambda, API Gateway, DynamoDB, CloudWatch'
//         }
//       ],
//       certifications: [
//         'AWS Certified Solutions Architect Professional',
//         'Microsoft Azure Solutions Architect Expert',
//         'Google Cloud Professional Cloud Architect'
//       ]
//     },
//     'AI Developer': {
//       summary: 'Innovative AI Developer specializing in building intelligent systems and machine learning models. Experienced in natural language processing, computer vision, and predictive analytics.',
//       skills: ['Python', 'TensorFlow', 'PyTorch', 'NLP', 'Computer Vision', 'Deep Learning', 'Data Preprocessing', 'Model Deployment'],
//       experience: [
//         {
//           title: 'AI Engineer',
//           company: 'Intelligent Systems Inc.',
//           duration: 'Jun 2021 - Present',
//           responsibilities: [
//             'Developed and deployed machine learning models for real-time image recognition with 95% accuracy',
//             'Built natural language processing pipelines for sentiment analysis and text classification',
//             'Optimized model performance and reduced inference time by 40%',
//             'Collaborated with product teams to integrate AI capabilities into business applications'
//           ]
//         },
//         {
//           title: 'Machine Learning Researcher',
//           company: 'AI Research Lab',
//           duration: 'Sep 2019 - May 2021',
//           responsibilities: [
//             'Conducted research on novel deep learning architectures',
//             'Implemented and evaluated state-of-the-art algorithms for computer vision tasks',
//             'Published two papers in leading AI conferences'
//           ]
//         }
//       ],
//       projects: [
//         {
//           name: 'Conversational AI Assistant',
//           description: 'Built an end-to-end conversational AI system with context understanding and natural responses',
//           technologies: 'Python, TensorFlow, BERT, Flask API'
//         },
//         {
//           name: 'Predictive Maintenance System',
//           description: 'Developed an anomaly detection system for industrial equipment using sensor data',
//           technologies: 'PyTorch, Time Series Analysis, IoT Integration'
//         }
//       ],
//       certifications: [
//         'TensorFlow Developer Certificate',
//         'NVIDIA Deep Learning Institute: Deep Learning Fundamentals',
//         'IBM AI Engineering Professional Certificate'
//       ]
//     },
//     'Business Analyst': {
//       summary: 'Results-driven Business Analyst with expertise in requirements gathering, process improvement, and data-driven decision making. Skilled in bridging the gap between business needs and technical solutions.',
//       skills: ['Requirements Analysis', 'Process Modeling', 'Data Analysis', 'SQL', 'Jira', 'Agile Methodologies', 'UML', 'Microsoft Office Suite'],
//       experience: [
//         {
//           title: 'Senior Business Analyst',
//           company: 'Enterprise Solutions',
//           duration: 'Aug 2021 - Present',
//           responsibilities: [
//             'Led requirements gathering sessions with stakeholders to define business needs and project scope',
//             'Created detailed business requirements documents and functional specifications',
//             'Conducted gap analysis to identify process improvement opportunities',
//             'Facilitated communication between technical teams and business stakeholders'
//           ]
//         },
//         {
//           title: 'Business Analyst',
//           company: 'Business Innovations Corp.',
//           duration: 'Mar 2019 - Jul 2021',
//           responsibilities: [
//             'Documented as-is and to-be business processes using BPMN',
//             'Created user stories and acceptance criteria for agile development teams',
//             'Performed data analysis to support business decisions'
//           ]
//         }
//       ],
//       projects: [
//         {
//           name: 'CRM System Implementation',
//           description: 'Led the requirements analysis and testing phases for a company-wide CRM implementation',
//           technologies: 'Salesforce, SQL, Process Modeling'
//         },
//         {
//           name: 'Supply Chain Optimization',
//           description: 'Analyzed supply chain processes and identified optimization opportunities saving $500K annually',
//           technologies: 'Excel, Power BI, Process Analysis'
//         }
//       ],
//       certifications: [
//         'IIBA Certified Business Analysis Professional (CBAP)',
//         'Agile Certified Practitioner (PMI-ACP)',
//         'Six Sigma Green Belt'
//       ]
//     }
//   };

//   // Function to generate keywords from job description
//   const extractKeywords = (jobDesc) => {
//     // In a real application, this would be a more sophisticated algorithm
//     // or use a natural language processing API
    
//     const commonTechKeywords = [
//       'javascript', 'react', 'angular', 'vue', 'node', 'express', 'python', 'django', 'flask',
//       'java', 'spring', 'hibernate', 'c#', '.net', 'php', 'laravel', 'ruby', 'rails',
//       'html', 'css', 'sass', 'less', 'bootstrap', 'tailwind', 'material-ui', 'responsive design',
//       'sql', 'mysql', 'postgresql', 'mongodb', 'nosql', 'firebase', 'redis', 'neo4j',
//       'rest api', 'graphql', 'soap', 'microservices', 'docker', 'kubernetes', 'aws', 'azure',
//       'gcp', 'devops', 'ci/cd', 'jenkins', 'git', 'github', 'gitlab', 'bitbucket',
//       'agile', 'scrum', 'kanban', 'jira', 'confluence', 'trello', 'asana',
//       'testing', 'jest', 'mocha', 'cypress', 'selenium', 'tdd', 'bdd',
//       'machine learning', 'artificial intelligence', 'data science', 'big data', 'hadoop', 'spark',
//       'tensorflow', 'pytorch', 'keras', 'nlp', 'computer vision', 'deep learning',
//       'blockchain', 'smart contracts', 'ethereum', 'solidity', 'web3',
//       'seo', 'analytics', 'google analytics', 'marketing automation', 'crm', 'salesforce',
//       'mobile development', 'ios', 'android', 'react native', 'flutter', 'xamarin',
//       'ux/ui', 'figma', 'sketch', 'adobe xd', 'invision', 'photoshop', 'illustrator'
//     ];
    
//     const softSkillKeywords = [
//       'communication', 'teamwork', 'leadership', 'problem solving', 'critical thinking',
//       'time management', 'organization', 'collaboration', 'adaptability', 'flexibility',
//       'creativity', 'innovation', 'detail oriented', 'analytical', 'strategic thinking',
//       'project management', 'decision making', 'conflict resolution', 'negotiation',
//       'customer service', 'interpersonal skills', 'presentation', 'verbal communication',
//       'written communication', 'emotional intelligence', 'mentoring', 'coaching'
//     ];
    
//     const allKeywords = [...commonTechKeywords, ...softSkillKeywords];
//     const jobDescLower = jobDesc.toLowerCase();
    
//     // Extract skills mentioned in the job description
//     const extractedKeywords = allKeywords.filter(keyword => 
//       jobDescLower.includes(keyword.toLowerCase())
//     );
    
//     return extractedKeywords;
//   };

//   // Function to generate resume based on job title or description
//   const generateResume = () => {
//     setIsGenerating(true);
    
//     // Determine which template to use based on job title
//     let selectedTemplate = null;
//     let jobTitleNormalized = jobTitle.trim();
    
//     // Match job title to template
//     for (const [templateKey, template] of Object.entries(jobTemplates)) {
//       if (jobTitleNormalized.toLowerCase().includes(templateKey.toLowerCase())) {
//         selectedTemplate = template;
//         break;
//       }
//     }
    
//     // If no specific template matches, use Software Developer as default
//     // In a real app, you would use NLP to better match or customize
//     if (!selectedTemplate) {
//       selectedTemplate = jobTemplates['Software Developer'];
      
//       // Try to customize based on job description if provided
//       if (jobDescription) {
//         const keywords = extractKeywords(jobDescription);
        
//         // Customize skills based on extracted keywords
//         if (keywords.length > 0) {
//           selectedTemplate = {
//             ...selectedTemplate,
//             skills: [...new Set([...keywords.slice(0, 8), ...selectedTemplate.skills])].slice(0, 10)
//           };
//         }
//       }
//     }
    
//     // Generate the resume data
//     const resumeData = {
//       ...selectedTemplate,
//       userData
//     };
    
//     // Set the generated resume
//     setGeneratedResume(resumeData);
//     setIsGenerating(false);
//   };

//   // Function to download resume as PDF
//   const downloadResume = () => {
//     if (!resumeRef.current) return;
    
//     const resumeElement = resumeRef.current;
    
//     html2canvas(resumeElement, {
//       scale: 2,
//       useCORS: true,
//       logging: false
//     }).then(canvas => {
//       const imgData = canvas.toDataURL('image/png');
//       const pdf = new jsPDF('p', 'mm', 'a4');
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = pdf.internal.pageSize.getHeight();
//       const imgWidth = canvas.width;
//       const imgHeight = canvas.height;
//       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
//       const imgX = (pdfWidth - imgWidth * ratio) / 2;
//       const imgY = 0;
      
//       pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
//       pdf.save('resume.pdf');
//     });
//   };

//   // Function to download resume as DOCX
//   const downloadResumeAsDocx = () => {
//     // In a real app, you would use a library like docx.js to create a Word document
//     // This is a simplified placeholder
//     alert('DOCX download functionality would be implemented using a library like docx.js');
//   };

//   // Function to check ATS score
//   const checkAtsScore = () => {
//     if (!uploadedResume || !atsJobDescription) {
//       alert('Please provide both a resume and job description');
//       return;
//     }
    
//     // In a real application, this would use NLP to analyze the resume against the job description
//     // This is a simplified implementation for demonstration
    
//     const keywords = extractKeywords(atsJobDescription);
//     const resumeLower = uploadedResume.toLowerCase();
    
//     // Count how many keywords from the job description appear in the resume
//     let matchedKeywords = 0;
//     let matchedKeywordsList = [];
    
//     keywords.forEach(keyword => {
//       if (resumeLower.includes(keyword.toLowerCase())) {
//         matchedKeywords++;
//         matchedKeywordsList.push(keyword);
//       }
//     });
    
//     // Calculate score (simplified algorithm)
//     const score = keywords.length > 0 ? Math.round((matchedKeywords / keywords.length) * 100) : 0;
    
//     setAtsScore({
//       score,
//       totalKeywords: keywords.length,
//       matched: matchedKeywords,
//       matchedKeywords: matchedKeywordsList,
//       missingKeywords: keywords.filter(kw => !matchedKeywordsList.includes(kw))
//     });
//   };

//   // Handle file upload for resume
//   const handleResumeUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
    
//     const reader = new FileReader();
//     reader.onload = (event) => {
//       setUploadedResume(event.target.result);
//     };
//     reader.readAsText(file);
//   };

//   // Update user data
//   const handleUserDataChange = (field, value) => {
//     setUserData({
//       ...userData,
//       [field]: value
//     });
//   };

//   return (
//     <div className="resume-builder-container my-5 py-5">
//       <header className="app-header">
//         <h1>Resume Builder & ATS Checker</h1>
//         <div className="tab-selector">
//           <button 
//             className={`tab-button ${activeTab === 'generator' ? 'active' : ''}`}
//             onClick={() => setActiveTab('generator')}
//           >
//             Resume Generator
//           </button>
//           <button 
//             className={`tab-button ${activeTab === 'atsChecker' ? 'active' : ''}`}
//             onClick={() => setActiveTab('atsChecker')}
//           >
//             ATS Score Checker
//           </button>
//         </div>
//       </header>

//       {activeTab === 'generator' && (
//         <div className="generator-section">
//           <div className="input-section">
//             <h2>Generate ATS-Friendly Resume</h2>
            
//             <div className="user-data-section">
//               <h3>Personal Information</h3>
//               <div className="form-group">
//                 <label>Full Name</label>
//                 <input
//                   type="text"
//                   value={userData.name}
//                   onChange={(e) => handleUserDataChange('name', e.target.value)}
//                   placeholder="Full Name"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>Email</label>
//                 <input
//                   type="email"
//                   value={userData.email}
//                   onChange={(e) => handleUserDataChange('email', e.target.value)}
//                   placeholder="Email"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>Phone</label>
//                 <input
//                   type="text"
//                   value={userData.phone}
//                   onChange={(e) => handleUserDataChange('phone', e.target.value)}
//                   placeholder="Phone"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>GitHub</label>
//                 <input
//                   type="text"
//                   value={userData.github}
//                   onChange={(e) => handleUserDataChange('github', e.target.value)}
//                   placeholder="GitHub URL"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>LinkedIn</label>
//                 <input
//                   type="text"
//                   value={userData.linkedin}
//                   onChange={(e) => handleUserDataChange('linkedin', e.target.value)}
//                   placeholder="LinkedIn URL"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>Portfolio</label>
//                 <input
//                   type="text"
//                   value={userData.portfolio}
//                   onChange={(e) => handleUserDataChange('portfolio', e.target.value)}
//                   placeholder="Portfolio URL"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>Education</label>
//                 <input
//                   type="text"
//                   value={userData.education}
//                   onChange={(e) => handleUserDataChange('education', e.target.value)}
//                   placeholder="Education"
//                 />
//               </div>
//             </div>
            
//             <div className="job-info-section">
//               <h3>Job Information</h3>
//               <div className="form-group">
//                 <label>Job Title</label>
//                 <input
//                   type="text"
//                   value={jobTitle}
//                   onChange={(e) => setJobTitle(e.target.value)}
//                   placeholder="Enter job title (e.g., Software Developer, Data Analyst)"
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>Job Description (Optional)</label>
//                 <textarea
//                   value={jobDescription}
//                   onChange={(e) => setJobDescription(e.target.value)}
//                   placeholder="Paste job description for better customization"
//                   rows={5}
//                 />
//               </div>
//             </div>
            
//             <button 
//               className="generate-button"
//               onClick={generateResume}
//               disabled={!jobTitle || isGenerating}
//             >
//               {isGenerating ? 'Generating...' : 'Generate Resume'}
//             </button>
//           </div>
          
//           <div className="output-section">
//             {generatedResume ? (
//               <>
//                 <div className="resume-preview-header">
//                   <h2>Resume Preview</h2>
//                   <div className="download-buttons">
//                     <button className="download-button" onClick={downloadResume}>
//                       Download PDF
//                     </button>
//                     <button className="download-button" onClick={downloadResumeAsDocx}>
//                       Download DOCX
//                     </button>
//                   </div>
//                 </div>
                
//                 <div className="resume-preview">
//                   <div className="resume-document" ref={resumeRef}>
//                     {/* Resume Header */}
//                     <div className="resume-header">
//                       <h1 className="resume-name">{userData.name}</h1>
//                       <p className="resume-education">{userData.education}</p>
//                       <div className="resume-contact-links">
//                         <span>{userData.email}</span>
//                         <span>{userData.phone}</span>
//                         <span>{userData.github}</span>
//                         <span>{userData.linkedin}</span>
//                         {userData.portfolio && <span>{userData.portfolio}</span>}
//                       </div>
//                     </div>
                    
//                     <hr className="resume-divider" />
                    
//                     {/* Professional Summary */}
//                     <div className="resume-section">
//                       <h2 className="section-heading">Professional Summary</h2>
//                       <p className="professional-summary">{generatedResume.summary}</p>
//                     </div>
                    
//                     {/* Work Experience */}
//                     <div className="resume-section">
//                       <h2 className="section-heading">Work Experience</h2>
//                       {generatedResume.experience.map((exp, index) => (
//                         <div className="experience-item" key={index}>
//                           <div className="experience-header">
//                             <h3>{exp.title}</h3>
//                             <p className="company-duration">
//                               <span className="company-name">{exp.company}</span>
//                               <span className="duration">{exp.duration}</span>
//                             </p>
//                           </div>
//                           <ul className="responsibilities">
//                             {exp.responsibilities.map((resp, i) => (
//                               <li key={i}>{resp}</li>
//                             ))}
//                           </ul>
//                         </div>
//                       ))}
//                     </div>
                    
//                     {/* Technical Skills */}
//                     <div className="resume-section">
//                       <h2 className="section-heading">Technical Skills</h2>
//                       <div className="skills-list">
//                         {generatedResume.skills.map((skill, index) => (
//                           <span className="skill-tag" key={index}>{skill}</span>
//                         ))}
//                       </div>
//                     </div>
                    
//                     {/* Projects */}
//                     <div className="resume-section">
//                       <h2 className="section-heading">Projects</h2>
//                       {generatedResume.projects.map((project, index) => (
//                         <div className="project-item" key={index}>
//                           <h3>{project.name}</h3>
//                           <p>{project.description}</p>
//                           <p className="technologies"><strong>Technologies:</strong> {project.technologies}</p>
//                         </div>
//                       ))}
//                     </div>
                    
//                     {/* Certifications */}
//                     <div className="resume-section">
//                       <h2 className="section-heading">Certifications</h2>
//                       <ul className="certifications-list">
//                         {generatedResume.certifications.map((cert, index) => (
//                           <li key={index}>{cert}</li>
//                         ))}
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               <div className="empty-preview">
//                 <p>Your resume preview will appear here</p>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {activeTab === 'atsChecker' && (
//         <div className="ats-checker-section">
//           <h2>ATS Score Checker</h2>
          
//           <div className="ats-input-container">
//             <div className="ats-input-column">
//               <h3>Job Description</h3>
//               <textarea
//                 className="ats-textarea"
//                 value={atsJobDescription}
//                 onChange={(e) => setAtsJobDescription(e.target.value)}
//                 placeholder="Paste the job description here"
//                 rows={15}
//               />
//             </div>
            
//             <div className="ats-input-column">
//               <h3>Resume</h3>
//               <div className="resume-upload">
//                 <textarea
//                   className="ats-textarea"
//                   value={uploadedResume}
//                   onChange={(e) => setUploadedResume(e.target.value)}
//                   placeholder="Paste your resume text here"
//                   rows={15}
//                 />
//                 <div className="upload-section">
//                   <p>Or upload a text file (.txt)</p>
//                   <input 
//                     type="file" 
//                     accept=".txt"
//                     onChange={handleResumeUpload}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           <button 
//             className="ats-check-button"
//             onClick={checkAtsScore}
//             disabled={!uploadedResume || !atsJobDescription}
//           >
//             Check ATS Score
//           </button>
          
//           {atsScore && (
//             <div className="ats-results">
//               <h3>ATS Score Analysis</h3>
              
//               <div className="score-meter">
//                 <div className="score-display">
//                   <div className={`score-value ${
//                     atsScore.score >= 80 ? 'excellent' : 
//                     atsScore.score >= 60 ? 'good' : 
//                     atsScore.score >= 40 ? 'fair' : 'poor'
//                   }`}>
//                     {atsScore.score}%
//                   </div>
//                   <div className="score-label">
//                     {
//                       atsScore.score >= 80 ? 'Excellent' : 
//                       atsScore.score >= 60 ? 'Good' : 
//                       atsScore.score >= 40 ? 'Fair' : 'Poor'
//                     }
//                   </div>
//                 </div>
//                 <div className="score-gauge">
//                   <div 
//                     className="score-fill"
//                     style={{width: `${atsScore.score}%`}}
//                   ></div>
//                 </div>
//               </div>
              
//               <div className="score-details">
//                 <div className="detail-item">
//                   <h4>Matched Keywords: {atsScore.matched}/{atsScore.totalKeywords}</h4>
//                   <div className="keyword-list">
//                     {atsScore.matchedKeywords.map((keyword, index) => (
//                       <span className="keyword matched" key={index}>{keyword}</span>
//                     ))}
//                   </div>
//                 </div>
                
//                 <div className="detail-item">
//                   <h4>Missing Keywords: {atsScore.totalKeywords - atsScore.matched}/{atsScore.totalKeywords}</h4>
//                   <div className="keyword-list">
//                     {atsScore.missingKeywords.map((keyword, index) => (
//                       <span className="keyword missing" key={index}>{keyword}</span>
//                     ))}
//                   </div>
//                 </div>
                
//                 <div className="recommendations">
//                   <h4>Recommendations:</h4>
//                   <ul>
//                     {atsScore.score < 80 && (
//                       <li>
//                         Add missing keywords to your resume where relevant to your experience
//                       </li>
//                     )}
//                     {atsScore.score < 70 && (
//                       <li>
//                         Ensure your resume uses the same terminology as the job description
//                       </li>
//                     )}
//                     {atsScore.score < 60 && (
//                       <li>
//                         Customize your resume specifically for this job role and description
//                       </li>
//                     )}
//                     {atsScore.score < 50 && (
//                       <li>
//                         Consider using our Resume Generator to create an optimized resume for this position
//                       </li>
//                     )}
//                     {atsScore.score >= 80 && (
//                       <li>
//                        Your resume is well-optimized for this job description! Make sure to proofread and ensure all information is accurate.
//                       </li>
//                     )}
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// export default ResumeBuilder1;


// import React, { useState, useRef } from 'react';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import "./resumebuilder.css";
// function ResumeBuilder1() {
//   // Main states for the application
//   const [activeTab, setActiveTab] = useState('generator'); // 'generator' or 'atsChecker'
//   const [jobTitle, setJobTitle] = useState('');
//   const [jobDescription, setJobDescription] = useState('');
//   const [generatedResume, setGeneratedResume] = useState(null);
//   const [isGenerating, setIsGenerating] = useState(false);
//   const [atsScore, setAtsScore] = useState(null);
//   const [uploadedResume, setUploadedResume] = useState('');
//   const [atsJobDescription, setAtsJobDescription] = useState('');

//   // Refs
//   const resumeRef = useRef(null);

//   // User data
//   const [userData, setUserData] = useState({
//     name: 'John Smith',
//     email: 'johnsmith@email.com',
//     phone: '(555) 123-4567',
//     github: 'github.com/johnsmith',
//     linkedin: 'linkedin.com/in/johnsmith',
//     portfolio: 'johnsmith.dev',
//     education: 'Bachelor of Computer Science, University of Technology (2018-2022)'
//   });

//   // Keyword databases
//   const industryKeywords = {
//     tech: [
//       'software', 'development', 'programming', 'coding', 'web', 'application', 'app', 'mobile',
//       'frontend', 'backend', 'full-stack', 'database', 'cloud', 'devops', 'agile', 'scrum',
//       'APIs', 'architecture', 'systems', 'algorithm', 'engineering', 'IT', 'information technology',
//       'quality assurance', 'QA', 'testing', 'cybersecurity', 'network', 'infrastructure'
//     ],
//     data: [
//       'analytics', 'analysis', 'reporting', 'statistics', 'metrics', 'KPIs', 'business intelligence',
//       'BI', 'dashboard', 'visualization', 'insights', 'trends', 'forecasting', 'modeling',
//       'big data', 'data mining', 'ETL', 'machine learning', 'ML', 'AI', 'artificial intelligence',
//       'database', 'SQL', 'NoSQL', 'data warehouse', 'data lake', 'data engineering', 'data science'
//     ],
//     design: [
//       'user experience', 'UX', 'user interface', 'UI', 'graphic design', 'visual design',
//       'wireframe', 'prototype', 'mockup', 'user-centered', 'responsive design', 'accessibility',
//       'usability', 'interaction design', 'information architecture', 'brand', 'creative'
//     ],
//     marketing: [
//       'digital marketing', 'content marketing', 'social media', 'SEO', 'SEM', 'PPC', 'CRM',
//       'campaign', 'strategy', 'branding', 'market research', 'customer acquisition', 'conversion',
//       'engagement', 'email marketing', 'analytics', 'advertising', 'promotion', 'growth'
//     ],
//     finance: [
//       'accounting', 'financial analysis', 'budgeting', 'forecasting', 'reporting', 'compliance',
//       'risk management', 'audit', 'taxation', 'investment', 'banking', 'financial planning',
//       'financial services', 'assets', 'liabilities', 'equity', 'profit', 'loss', 'cash flow'
//     ],
//     healthcare: [
//       'patient care', 'clinical', 'medical', 'health', 'healthcare', 'nursing', 'physician',
//       'treatment', 'diagnosis', 'therapy', 'rehabilitation', 'wellness', 'electronic health records',
//       'EHR', 'HIPAA', 'compliance', 'pharmaceuticals', 'biotech', 'research'
//     ],
//     education: [
//       'teaching', 'instruction', 'curriculum', 'assessment', 'learning', 'education', 'training',
//       'professional development', 'e-learning', 'instructional design', 'educational technology',
//       'pedagogy', 'academic', 'student', 'faculty', 'school', 'university', 'college'
//     ],
//     management: [
//       'leadership', 'strategy', 'operations', 'team management', 'supervision', 'project management',
//       'program management', 'resource allocation', 'decision making', 'planning', 'execution',
//       'stakeholder management', 'performance management', 'organizational development'
//     ]
//   };

//   const technicalSkillsDatabase = {
//     programming: [
//       'JavaScript', 'Python', 'Java', 'C#', 'C++', 'Ruby', 'PHP', 'Swift', 'Kotlin', 'Go', 
//       'TypeScript', 'Rust', 'Scala', 'Perl', 'Shell scripting', 'R', 'MATLAB', 'Objective-C'
//     ],
//     webDev: [
//       'HTML', 'CSS', 'React', 'Angular', 'Vue.js', 'Node.js', 'Express', 'Django', 'Flask',
//       'Ruby on Rails', 'Spring Boot', 'ASP.NET', 'jQuery', 'Bootstrap', 'Tailwind CSS',
//       'Sass', 'Less', 'Redux', 'GraphQL', 'RESTful APIs', 'SOAP', 'WebSockets'
//     ],
//     mobileDev: [
//       'React Native', 'Flutter', 'Swift', 'SwiftUI', 'UIKit', 'Kotlin', 'Java for Android',
//       'Android SDK', 'iOS Development', 'Xamarin', 'Ionic', 'Cordova', 'Mobile UI/UX',
//       'App Store Optimization', 'Push Notifications', 'Mobile Analytics'
//     ],
//     database: [
//       'SQL', 'MySQL', 'PostgreSQL', 'Oracle', 'SQL Server', 'MongoDB', 'Redis', 'Cassandra',
//       'DynamoDB', 'Firebase', 'Neo4j', 'Elasticsearch', 'Snowflake', 'BigQuery', 'Redshift',
//       'NoSQL', 'Database Design', 'Data Modeling', 'ETL', 'Data Warehousing'
//     ],
//     cloud: [
//       'AWS', 'Azure', 'Google Cloud', 'Kubernetes', 'Docker', 'Terraform', 'CloudFormation',
//       'Lambda', 'EC2', 'S3', 'RDS', 'IAM', 'Cloud Security', 'Serverless', 'Microservices',
//       'Service Mesh', 'Istio', 'API Gateway', 'Cloud Architecture', 'SaaS', 'PaaS', 'IaaS'
//     ],
//     dataScience: [
//       'Machine Learning', 'Deep Learning', 'Neural Networks', 'NLP', 'Computer Vision',
//       'TensorFlow', 'PyTorch', 'Keras', 'Scikit-learn', 'Pandas', 'NumPy', 'SciPy',
//       'Data Visualization', 'Tableau', 'Power BI', 'D3.js', 'Matplotlib', 'Seaborn',
//       'Statistical Analysis', 'A/B Testing', 'Regression Analysis', 'Classification'
//     ],
//     tools: [
//       'Git', 'GitHub', 'GitLab', 'Bitbucket', 'JIRA', 'Confluence', 'Trello', 'Asana',
//       'Slack', 'Microsoft Teams', 'Jenkins', 'Travis CI', 'CircleCI', 'GitHub Actions',
//       'Docker', 'Kubernetes', 'Terraform', 'Ansible', 'Chef', 'Puppet', 'New Relic',
//       'Datadog', 'Splunk', 'ELK Stack', 'Prometheus', 'Grafana'
//     ]
//   };

//   const softSkillsDatabase = [
//     'Communication', 'Teamwork', 'Problem-solving', 'Time management', 'Leadership',
//     'Adaptability', 'Critical thinking', 'Creativity', 'Emotional intelligence',
//     'Attention to detail', 'Organization', 'Work ethic', 'Interpersonal skills',
//     'Conflict resolution', 'Decision making', 'Negotiation', 'Collaboration',
//     'Strategic thinking', 'Analytical thinking', 'Customer service', 'Active listening',
//     'Empathy', 'Flexibility', 'Patience', 'Resilience', 'Self-motivation',
//     'Networking', 'Public speaking', 'Presentation skills', 'Cultural awareness'
//   ];

//   // Function to extract keywords from job description
//   const extractKeywords = (jobDesc) => {
//     if (!jobDesc) return [];
    
//     const jobDescLower = jobDesc.toLowerCase();
//     let extractedKeywords = [];
    
//     // Extract technical skills
//     for (const category in technicalSkillsDatabase) {
//       for (const skill of technicalSkillsDatabase[category]) {
//         if (jobDescLower.includes(skill.toLowerCase())) {
//           extractedKeywords.push(skill);
//         }
//       }
//     }
    
//     // Extract soft skills
//     for (const skill of softSkillsDatabase) {
//       if (jobDescLower.includes(skill.toLowerCase())) {
//         extractedKeywords.push(skill);
//       }
//     }
    
//     // Extract industry-specific terms
//     for (const industry in industryKeywords) {
//       for (const term of industryKeywords[industry]) {
//         if (jobDescLower.includes(term.toLowerCase())) {
//           extractedKeywords.push(term);
//         }
//       }
//     }
    
//     // Remove duplicates and limit to most relevant
//     return [...new Set(extractedKeywords)].slice(0, 15);
//   };

//   // Function to determine main industry/field from job description
//   const determineIndustry = (jobDesc, jobTitleInput) => {
//     if (!jobDesc && !jobTitleInput) return 'tech'; // Default to tech if no info
    
//     const combinedText = (jobDesc + ' ' + jobTitleInput).toLowerCase();
    
//     const industryScores = {};
    
//     // Score each industry by counting matching keywords
//     for (const [industry, keywords] of Object.entries(industryKeywords)) {
//       let score = 0;
//       for (const keyword of keywords) {
//         if (combinedText.includes(keyword.toLowerCase())) {
//           score += 1;
//         }
//       }
//       industryScores[industry] = score;
//     }
    
//     // Find industry with highest score
//     let maxScore = 0;
//     let dominantIndustry = 'tech';
    
//     for (const [industry, score] of Object.entries(industryScores)) {
//       if (score > maxScore) {
//         maxScore = score;
//         dominantIndustry = industry;
//       }
//     }
    
//     return dominantIndustry;
//   };

//   // Function to generate skills based on job description and title
//   const generateSkills = (jobDesc, jobTitleInput, industry) => {
//     const extractedKeywords = extractKeywords(jobDesc);
    
//     // Build a base set of skills from the determined industry
//     let industrySpecificSkills = [];
    
//     // Add programming and web dev skills for tech industry
//     if (industry === 'tech') {
//       industrySpecificSkills = [
//         ...pickRandom(technicalSkillsDatabase.programming, 3),
//         ...pickRandom(technicalSkillsDatabase.webDev, 3),
//         ...pickRandom(technicalSkillsDatabase.tools, 2)
//       ];
//     }
//     // Add data skills for data industry
//     else if (industry === 'data') {
//       industrySpecificSkills = [
//         ...pickRandom(technicalSkillsDatabase.dataScience, 4),
//         ...pickRandom(technicalSkillsDatabase.programming, 2),
//         ...pickRandom(technicalSkillsDatabase.database, 2)
//       ];
//     }
//     // Default mix of skills for other industries
//     else {
//       industrySpecificSkills = [
//         ...pickRandom(technicalSkillsDatabase.programming, 2),
//         ...pickRandom(technicalSkillsDatabase.tools, 2),
//         ...pickRandom(technicalSkillsDatabase.database, 1)
//       ];
//     }
    
//     // Combine with extracted keywords
//     const combinedSkills = [...extractedKeywords, ...industrySpecificSkills];
    
//     // Deduplicate and limit to 10-12 skills
//     return [...new Set(combinedSkills)].slice(0, 12);
//   };

//   // Function to generate a professional summary
//   const generateSummary = (jobTitle, jobDesc, industry) => {
//     const extractedKeywords = extractKeywords(jobDesc).slice(0, 5);
//     const jobTitleNormalized = jobTitle.trim();
    
//     // Base templates for different industries
//     const summaryTemplates = {
//       tech: [
//         `Dedicated {{role}} with {{years}} years of experience in {{keyword1}} and {{keyword2}}. Proven track record of {{keyword3}} and driving {{keyword4}} initiatives. Strong expertise in {{keyword5}} with a focus on delivering high-quality solutions.`,
//         `Results-oriented {{role}} specializing in {{keyword1}} and {{keyword2}}. Experienced in {{keyword3}} with a strong background in {{keyword4}}. Skilled at {{keyword5}} and committed to continuous improvement.`,
//         `Innovative {{role}} with experience in building {{keyword1}} solutions using {{keyword2}}. Strong problem-solving skills and expertise in {{keyword3}} and {{keyword4}}. Passionate about {{keyword5}} and delivering exceptional results.`
//       ],
//       data: [
//         `Data-driven {{role}} with expertise in extracting actionable insights from complex datasets. Proficient in {{keyword1}}, {{keyword2}}, and {{keyword3}}. Experience implementing {{keyword4}} solutions and communicating findings to {{keyword5}}.`,
//         `Detail-oriented {{role}} specializing in {{keyword1}} and {{keyword2}}. Proven ability to translate {{keyword3}} into business recommendations. Skilled in {{keyword4}} and {{keyword5}} to drive data-informed decision making.`,
//         `Analytical {{role}} with strong background in {{keyword1}} and {{keyword2}}. Experienced in building {{keyword3}} solutions and performing {{keyword4}} to uncover insights. Adept at communicating complex data concepts to {{keyword5}}.`
//       ],
//       default: [
//         `Experienced {{role}} with {{years}} years of expertise in {{keyword1}} and {{keyword2}}. Proven ability to {{keyword3}} while maintaining focus on {{keyword4}}. Skilled in {{keyword5}} and dedicated to achieving exceptional results.`,
//         `Results-driven {{role}} with demonstrated success in {{keyword1}} and {{keyword2}}. Experience in {{keyword3}} and {{keyword4}} with a commitment to {{keyword5}} and continuous improvement.`,
//         `Dedicated {{role}} with expertise in {{keyword1}}. Skilled in {{keyword2}} and {{keyword3}} with a focus on {{keyword4}}. Passionate about {{keyword5}} and delivering value to organizations.`
//       ]
//     };
    
//     // Select template
//     const templates = summaryTemplates[industry] || summaryTemplates.default;
//     const template = templates[Math.floor(Math.random() * templates.length)];
    
//     // Fill in template
//     const years = Math.floor(Math.random() * 5) + 2; // Random 2-7 years experience
//     const filledTemplate = template
//       .replace('{{role}}', jobTitleNormalized)
//       .replace('{{years}}', years.toString())
//       .replace('{{keyword1}}', extractedKeywords[0] || 'project management')
//       .replace('{{keyword2}}', extractedKeywords[1] || 'team collaboration')
//       .replace('{{keyword3}}', extractedKeywords[2] || 'problem solving')
//       .replace('{{keyword4}}', extractedKeywords[3] || 'process improvement')
//       .replace('{{keyword5}}', extractedKeywords[4] || 'innovative solutions');
    
//     return filledTemplate;
//   };

//   // Function to generate work experience
//   const generateWorkExperience = (jobTitle, jobDesc, industry) => {
//     const keywords = extractKeywords(jobDesc);
//     const jobTitleWords = jobTitle.toLowerCase().split(' ');
    
//     // Generate company names based on industry
//     const companyNameTemplates = {
//       tech: ['Tech Solutions', 'Innovate Systems', 'Digital Dynamics', 'CodeCraft', 'NextGen Technologies'],
//       data: ['Data Insights', 'Analytics Hub', 'Metric Masters', 'DataCore Solutions', 'Insight Analytics'],
//       finance: ['Financial Strategies', 'Capital Partners', 'Investment Solutions', 'Wealth Advisors', 'Financial Dynamics'],
//       healthcare: ['Health Innovations', 'MediCore Systems', 'Wellness Solutions', 'Care Technologies', 'Health Partners'],
//       marketing: ['Marketing Dynamics', 'Brand Builders', 'Engagement Strategies', 'Digital Presence', 'Growth Marketing'],
//       design: ['Design Collective', 'Creative Solutions', 'UX Innovations', 'Visual Dynamics', 'Design Masters'],
//       education: ['Learning Innovations', 'Educational Systems', 'Knowledge Partners', 'Academic Solutions', 'EdTech Dynamics'],
//       management: ['Strategic Management', 'Leadership Partners', 'Organizational Solutions', 'Management Innovations', 'Business Strategy Group']
//     };
    
//     const companies = companyNameTemplates[industry] || companyNameTemplates.tech;
    
//     // Generate titles related to the job title
//     const generateRelatedTitles = (baseTitle) => {
//       const prefixes = ['Senior ', 'Lead ', 'Principal ', 'Junior ', 'Associate '];
//       const suffixes = [' Specialist', ' Analyst', ' Consultant', ' Engineer', ' Developer'];
//       const related = [];
      
//       // Use the original title
//       related.push(baseTitle);
      
//       // Add a prefixed version if not already present
//       const randomPrefix = prefixes[Math.floor(Math.random() * prefixes.length)];
//       if (!baseTitle.includes(randomPrefix)) {
//         related.push(randomPrefix + baseTitle);
//       }
      
//       // Add a suffixed version if appropriate
//       if (!jobTitleWords.some(word => suffixes.some(suffix => suffix.toLowerCase().includes(word)))) {
//         const randomSuffix = suffixes[Math.floor(Math.random() * suffixes.length)];
//         related.push(baseTitle + randomSuffix);
//       }
      
//       return related;
//     };
    
//     const relatedTitles = generateRelatedTitles(jobTitle);
    
//     // Generate responsibilities based on keywords and industry
//     const generateResponsibilities = (role, keywords, industry) => {
//       const responsibilityTemplates = {
//         tech: [
//           'Developed and maintained {{keyword}} applications',
//           'Implemented {{keyword}} features for client projects',
//           'Collaborated with cross-functional teams to deliver {{keyword}} solutions',
//           'Designed and optimized {{keyword}} systems',
//           'Performed code reviews and provided technical mentorship on {{keyword}}',
//           'Resolved complex technical issues related to {{keyword}}',
//           'Created technical documentation for {{keyword}} implementations',
//           'Improved system performance by optimizing {{keyword}} components'
//         ],
//         data: [
//           'Analyzed large datasets using {{keyword}} techniques',
//           'Created reports and dashboards to visualize {{keyword}} metrics',
//           'Developed {{keyword}} models to improve business decision-making',
//           'Performed {{keyword}} analysis to identify trends and patterns',
//           'Built automated {{keyword}} pipelines for regular reporting',
//           'Collaborated with stakeholders to define {{keyword}} requirements',
//           'Maintained data quality standards for {{keyword}} datasets',
//           'Presented {{keyword}} insights to executive leadership'
//         ],
//         default: [
//           'Led projects focusing on {{keyword}} implementation',
//           'Managed {{keyword}} processes and workflows',
//           'Developed strategies for improving {{keyword}} outcomes',
//           'Collaborated with team members on {{keyword}} initiatives',
//           'Created documentation for {{keyword}} procedures',
//           'Analyzed {{keyword}} performance and recommended improvements',
//           'Trained team members on {{keyword}} best practices',
//           'Implemented new {{keyword}} methodologies'
//         ]
//       };
      
//       const templates = responsibilityTemplates[industry] || responsibilityTemplates.default;
//       const roleLower = role.toLowerCase();
      
//       // Select 4-6 responsibility templates
//       const selectedTemplates = pickRandom(templates, Math.floor(Math.random() * 3) + 4);
      
//       // Fill templates with keywords
//       return selectedTemplates.map(template => {
//         const keyword = keywords[Math.floor(Math.random() * keywords.length)] || 'relevant';
//         return template.replace('{{keyword}}', keyword);
//       });
//     };
    
//     // Generate work experience entries
//     const generateExperienceEntries = () => {
//       const currentYear = new Date().getFullYear();
//       const entries = [];
      
//       // Current/most recent position
//       entries.push({
//         title: relatedTitles[0],
//         company: companies[0],
//         duration: `${currentYear - 2} - Present`,
//         responsibilities: generateResponsibilities(relatedTitles[0], keywords, industry)
//       });
      
//       // Previous position
//       if (relatedTitles.length > 1) {
//         entries.push({
//           title: relatedTitles[1],
//           company: companies[1] || companies[0] + ' International',
//           duration: `${currentYear - 5} - ${currentYear - 2}`,
//           responsibilities: generateResponsibilities(relatedTitles[1], keywords, industry)
//         });
//       }
      
//       // Even earlier position (optional)
//       if (Math.random() > 0.5 && relatedTitles.length > 2) {
//         entries.push({
//           title: relatedTitles[2],
//           company: companies[2] || pickRandom(companies, 1)[0],
//           duration: `${currentYear - 7} - ${currentYear - 5}`,
//           responsibilities: generateResponsibilities(relatedTitles[2], keywords, industry)
//         });
//       }
      
//       return entries;
//     };
    
//     return generateExperienceEntries();
//   };

//   // Function to generate projects
//   const generateProjects = (jobTitle, skills, industry) => {
//     const projectNameTemplates = {
//       tech: [
//         'E-commerce Platform',
//         'Content Management System',
//         'Task Management Application',
//         'Social Media Dashboard',
//         'Customer Relationship Management Tool',
//         'Enterprise Resource Planning System',
//         'Mobile Payment Application',
//         'Real-time Chat Application',
//         'Inventory Management System'
//       ],
//       data: [
//         'Customer Segmentation Analysis',
//         'Sales Forecasting Model',
//         'Predictive Maintenance System',
//         'Marketing ROI Dashboard',
//         'Supply Chain Optimization',
//         'Customer Churn Prediction',
//         'Recommendation Engine',
//         'Fraud Detection System',
//         'Automated Reporting Platform'
//       ],
//       default: [
//         'Process Improvement Initiative',
//         'Strategic Planning Tool',
//         'Team Collaboration Platform',
//         'Performance Tracking System',
//         'Resource Allocation Optimizer',
//         'Client Management Portal',
//         'Digital Transformation Project',
//         'Workflow Automation System'
//       ]
//     };
    
//     const projectDescriptionTemplates = {
//       tech: [
//         'Built a {{feature}} with {{technology}} and {{technology2}}',
//         'Developed a {{feature}} that improved {{metric}} by {{percentage}}%',
//         'Created a scalable {{feature}} using {{technology}} architecture',
//         'Implemented a {{feature}} with focus on {{attribute}} and {{attribute2}}',
//         'Designed and built a {{feature}} that handled {{volume}} of user data'
//       ],
//       data: [
//         'Analyzed {{datatype}} to identify {{insight}} leading to {{outcome}}',
//         'Built a predictive model for {{purpose}} with {{percentage}}% accuracy',
//         'Created interactive dashboards to visualize {{insight}} using {{technology}}',
//         'Developed ETL pipelines for {{datatype}} processing using {{technology}}',
//         'Implemented {{algorithm}} algorithms to solve {{challenge}} problems'
//       ],
//       default: [
//         'Led a project to improve {{process}} resulting in {{outcome}}',
//         'Developed a strategy for {{purpose}} that increased {{metric}} by {{percentage}}%',
//         'Created a system to automate {{process}} reducing time spent by {{percentage}}%',
//         'Implemented a new approach to {{process}} that enhanced {{attribute}}',
//         'Designed a solution for {{challenge}} using {{methodology}} techniques'
//       ]
//     };
    
//     const projectFeatures = [
//       'user authentication system', 'payment processing module', 'inventory tracking system',
//       'real-time notification feature', 'data visualization component', 'API integration',
//       'responsive user interface', 'recommendation algorithm', 'search functionality',
//       'automated reporting system', 'user management module', 'content delivery network'
//     ];
    
//     const dataTypes = [
//       'customer transaction data', 'user behavior logs', 'time series data',
//       'unstructured text', 'survey responses', 'sensor data', 'social media feeds',
//       'sales records', 'website analytics', 'market research data'
//     ];
    
//     const insights = [
//       'customer segments', 'purchase patterns', 'usage trends',
//       'performance bottlenecks', 'growth opportunities', 'cost reduction areas',
//       'user preferences', 'market trends', 'operational inefficiencies'
//     ];
    
//     const outcomes = [
//       'increased revenue', 'reduced costs', 'improved user satisfaction',
//       'faster processing times', 'higher conversion rates', 'better retention',
//       'streamlined operations', 'enhanced decision making', 'competitive advantage'
//     ];
    
//     const processes = [
//       'customer onboarding', 'data entry', 'quality assurance', 'order fulfillment',
//       'inventory management', 'document processing', 'approval workflows',
//       'reporting', 'resource allocation', 'team collaboration'
//     ];
    
//     const metrics = [
//       'efficiency', 'productivity', 'revenue', 'user engagement',
//       'customer satisfaction', 'conversion rate', 'retention rate',
//       'response time', 'system uptime', 'error rate'
//     ];
    
//     const attributes = [
//       'scalability', 'performance', 'security', 'usability',
//       'accessibility', 'reliability', 'maintainability', 'extensibility'
//     ];
    
//     const volumes = [
//       'millions of records', 'terabytes of data', 'thousands of transactions per second',
//       'hundreds of concurrent users', 'global user base', 'petabyte-scale databases'
//     ];
    
//     const percentages = [20, 25, 30, 35, 40, 45, 50, 60, 75, 90];
    
//     // Generate projects
//     const generateProjectEntries = () => {
//       const entries = [];
//       const projectNames = projectNameTemplates[industry] || projectNameTemplates.default;
//       const descTemplates = projectDescriptionTemplates[industry] || projectDescriptionTemplates.default;
      
//       // Select 2-3 project names
//       const selectedProjectNames = pickRandom(projectNames, Math.floor(Math.random() * 2) + 2);
      
//       selectedProjectNames.forEach(projectName => {
//         // Select a random description template
//         const descTemplate = pickRandom(descTemplates, 1)[0];
        
//         // Fill in the template based on industry
//         let description;
//         if (industry === 'tech') {
//           description = descTemplate
//             .replace('{{feature}}', pickRandom(projectFeatures, 1)[0])
//             .replace('{{technology}}', pickRandom(skills, 1)[0])
//             .replace('{{technology2}}', pickRandom(skills, 1)[0])
//             .replace('{{metric}}', pickRandom(metrics, 1)[0])
//             .replace('{{percentage}}', pickRandom(percentages, 1)[0])
//             .replace('{{attribute}}', pickRandom(attributes, 1)[0])
//             .replace('{{attribute2}}', pickRandom(attributes, 1)[0])
//             .replace('{{volume}}', pickRandom(volumes, 1)[0]);
//         } else if (industry === 'data') {
//           description = descTemplate
//             .replace('{{datatype}}', pickRandom(dataTypes, 1)[0])
//             .replace('{{insight}}', pickRandom(insights, 1)[0])
//             .replace('{{outcome}}', pickRandom(outcomes, 1)[0])
//             .replace('{{purpose}}', pickRandom(processes, 1)[0])
//             .replace('{{percentage}}', pickRandom(percentages, 1)[0])
//             .replace('{{technology}}', pickRandom(skills, 1)[0])
//             .replace('{{algorithm}}', pickRandom(['machine learning', 'predictive', 'classification', 'clustering'], 1)[0])
//             .replace('{{challenge}}', pickRandom(['optimization', 'prediction', 'classification', 'anomaly detection'], 1)[0]);
//         } else {
//           description = descTemplate
//             .replace('{{process}}', pickRandom(processes, 1)[0])
//             .replace('{{outcome}}', pickRandom(outcomes, 1)[0])
//             .replace('{{purpose}}', pickRandom(processes, 1)[0])
//             .replace('{{metric}}', pickRandom(metrics, 1)[0])
//             .replace('{{percentage}}', pickRandom(percentages, 1)[0])
//             .replace('{{attribute}}', pickRandom(attributes, 1)[0])
//             .replace('{{challenge}}', pickRandom(['efficiency', 'productivity', 'user experience', 'performance'], 1)[0])
//             .replace('{{methodology}}', pickRandom(['agile', 'lean', 'design thinking', 'six sigma'], 1)[0]);
//         }
        
//         // Generate technologies used
//         const projectSkills = pickRandom(skills, 3).join(', ');
        
//         entries.push({
//           name: projectName,
//           description: description,
//           technologies: projectSkills
//         });
//       });
      
//       return entries;
//     };
    
//     return generateProjectEntries();
//   };

//   // Function to generate certifications
//   const generateCertifications = (jobTitle, skills, industry) => {
//     const certificationTemplates = {
//       tech: [
//         'AWS Certified Solutions Architect',
//         'Microsoft Certified: Azure Developer Associate',
//         'Google Professional Cloud Architect',
//         'Certified Kubernetes Administrator (CKA)',
//         'Certified Scrum Master (CSM)',
//         'Project Management Professional (PMP)',
//         'CompTIA Security+',
//         'Oracle Certified Professional: Java SE 11 Developer',
//         'Certified Information Systems Security Professional (CISSP)',
//         'Certified ScrumMaster (CSM)',
//         'MongoDB Certified Developer',
//         'Cisco Certified Network Associate (CCNA)'
//       ],
//       data: [
//         'Microsoft Certified: Data Analyst Associate',
//         'Google Data Analytics Professional Certificate',
//         'AWS Certified Data Analytics - Specialty',
//         'Cloudera Certified Associate: Data Analyst',
//         'IBM Data Science Professional Certificate',
//         'Tableau Desktop Specialist',
//         'SAS Certified Data Scientist',
//         'MongoDB Certified DBA',
//         'Certified Analytics Professional (CAP)',
//         'Microsoft Certified: Azure Data Scientist Associate',
//         'Google Professional Data Engineer',
//         'Snowflake SnowPro Core Certification'
//       ],
    
//     design: [
//       'Adobe Certified Expert (ACE)',
//       'Certified User Experience Professional (CUXP)',
//       'Interaction Design Foundation Certification',
//       'Google UX Design Professional Certificate',
//       'Certified Graphic Designer',
//       'Autodesk Certified Professional',
//       'Certified Web Designer',
//       'User Experience Designer Certification',
//       'Information Architecture Professional'
//     ],
//     marketing: [
//       'Google Ads Certification',
//       'HubSpot Content Marketing Certification',
//       'Facebook Blueprint Certification',
//       'Hootsuite Social Marketing Certification',
//       'Google Analytics Individual Qualification',
//       'HubSpot Inbound Marketing Certification',
//       'Certified Digital Marketing Professional',
//       'SEO Certification',
//       'Email Marketing Certification'
//     ],
//     finance: [
//       'Certified Public Accountant (CPA)',
//       'Chartered Financial Analyst (CFA)',
//       'Certified Financial Planner (CFP)',
//       'Financial Risk Manager (FRM)',
//       'Certified Management Accountant (CMA)',
//       'Chartered Alternative Investment Analyst (CAIA)',
//       'Certified Internal Auditor (CIA)',
//       'Enrolled Agent (EA)',
//       'Certified Information Systems Auditor (CISA)'
//     ],
//     healthcare: [
//       'Certified Professional in Healthcare Quality (CPHQ)',
//       'Registered Health Information Administrator (RHIA)',
//       'Certified Healthcare Financial Professional (CHFP)',
//       'Certified in Healthcare Compliance (CHC)',
//       'Certified Professional in Electronic Health Records (CPEHR)',
//       'Certified Healthcare Technology Specialist (CHTS)',
//       'Certified Medical Practice Executive (CMPE)',
//       'Certified Professional in Healthcare Risk Management (CPHRM)',
//       'Health Information Management Certification'
//     ],
//     default: [
//       'Project Management Professional (PMP)',
//       'Certified ScrumMaster (CSM)',
//       'Lean Six Sigma Green Belt',
//       'Certified Business Analysis Professional (CBAP)',
//       'Certified Associate in Project Management (CAPM)',
//       'ITIL Foundation Certification',
//       'Certified Manager (CM)',
//       'Professional in Human Resources (PHR)',
//       'Certified Professional in Learning and Performance (CPLP)'
//     ]
//   };

  
//   const certList = certificationTemplates[industry] || certificationTemplates.default;
  
//   // Select 1-3 certifications based on skills and job title
//   let relevantCerts = [];
  
//   // Check for specific skills in the skills list
//   if (skills.some(skill => ['AWS', 'Amazon', 'Cloud'].some(term => skill.includes(term)))) {
//     const awsCerts = certificationTemplates.tech.filter(cert => cert.includes('AWS'));
//     if (awsCerts.length > 0) relevantCerts.push(awsCerts[0]);
//   }
  
//   if (skills.some(skill => ['Azure', 'Microsoft'].some(term => skill.includes(term)))) {
//     const microsoftCerts = certificationTemplates.tech.filter(cert => cert.includes('Microsoft'));
//     if (microsoftCerts.length > 0) relevantCerts.push(microsoftCerts[0]);
//   }
  
//   if (skills.some(skill => ['Google', 'GCP'].some(term => skill.includes(term)))) {
//     const googleCerts = certificationTemplates.tech.filter(cert => cert.includes('Google'));
//     if (googleCerts.length > 0) relevantCerts.push(googleCerts[0]);
//   }
  
//   // If we don't have enough relevant certs yet, add some random ones
//   if (relevantCerts.length < 2) {
//     const randomCerts = pickRandom(certList.filter(cert => !relevantCerts.includes(cert)), 2 - relevantCerts.length);
//     relevantCerts = [...relevantCerts, ...randomCerts];
//   }
  
//   return relevantCerts;
// };

// // Helper function to pick random items from an array
// const pickRandom = (array, count) => {
//   const shuffled = [...array].sort(() => 0.5 - Math.random());
//   return shuffled.slice(0, count);
// };

// // Function to generate tailored resume
// const generateResumeHandler = async () => {
//   if (!jobTitle || !jobDescription) {
//     alert('Please enter both job title and job description.');
//     return;
//   }
  
//   setIsGenerating(true);
  
//   try {
//     // Simulate API delay
//     await new Promise(resolve => setTimeout(resolve, 1500));
    
//     // Determine industry from job description and title
//     const industry = determineIndustry(jobDescription, jobTitle);
    
//     // Generate skills based on job description
//     const skills = generateSkills(jobDescription, jobTitle, industry);
    
//     // Generate professional summary
//     const summary = generateSummary(jobTitle, jobDescription, industry);
    
//     // Generate work experience
//     const experience = generateWorkExperience(jobTitle, jobDescription, industry);
    
//     // Generate projects
//     const projects = generateProjects(jobTitle, skills, industry);
    
//     // Generate certifications
//     const certifications = generateCertifications(jobTitle, skills, industry);
    
//     // Set the generated resume
//     setGeneratedResume({
//       summary,
//       skills,
//       experience,
//       projects,
//       certifications,
//       industry
//     });
    
//     setIsGenerating(false);
//   } catch (error) {
//     console.error('Error generating resume:', error);
//     setIsGenerating(false);
//     alert('An error occurred while generating your resume. Please try again.');
//   }
// };

// // Function to analyze resume for ATS compatibility
// const analyzeResumeHandler = async () => {
//   if (!uploadedResume || !atsJobDescription) {
//     alert('Please upload a resume and enter a job description for ATS analysis.');
//     return;
//   }
  
//   setIsGenerating(true);
  
//   try {
//     // Simulate API delay
//     await new Promise(resolve => setTimeout(resolve, 2000));
    
//     // Extract keywords from job description
//     const jobKeywords = extractKeywords(atsJobDescription);
    
//     // Simulate keyword matching analysis
//     const resumeLower = uploadedResume.toLowerCase();
//     const matchedKeywords = jobKeywords.filter(keyword => 
//       resumeLower.includes(keyword.toLowerCase())
//     );
    
//     // Calculate match percentage
//     const matchPercentage = Math.round((matchedKeywords.length / jobKeywords.length) * 100);
    
//     // Generate feedback based on match percentage
//     let feedback;
//     let suggestions = [];
    
//     if (matchPercentage >= 80) {
//       feedback = "Excellent match! Your resume is well-aligned with this job description.";
//       suggestions = [
//         "Consider adding more specific achievements with measurable results",
//         "Ensure your formatting is ATS-friendly with standard section headings"
//       ];
//     } else if (matchPercentage >= 60) {
//       feedback = "Good match, but there's room for improvement to better align with this job.";
//       suggestions = [
//         "Add more industry-specific keywords from the job description",
//         "Highlight relevant projects that showcase required skills",
//         "Quantify your achievements with metrics and results"
//       ];
//     } else {
//       feedback = "Your resume needs significant updates to match this job description.";
//       suggestions = [
//         "Restructure your resume to highlight relevant experience",
//         "Add missing key skills mentioned in the job description",
//         "Use industry-standard terminology",
//         "Include specific achievements related to the job requirements",
//         "Consider customizing your professional summary"
//       ];
//     }
    
//     // Generate list of missing keywords
//     const missingKeywords = jobKeywords.filter(keyword => 
//       !matchedKeywords.includes(keyword)
//     );
    
//     setAtsScore({
//       score: matchPercentage,
//       matchedKeywords,
//       missingKeywords,
//       feedback,
//       suggestions
//     });
    
//     setIsGenerating(false);
//   } catch (error) {
//     console.error('Error analyzing resume:', error);
//     setIsGenerating(false);
//     alert('An error occurred during ATS analysis. Please try again.');
//   }
// };

// // Function to download resume as PDF
// const downloadResumeAsPdf = () => {
//   if (!resumeRef.current) return;
  
//   const input = resumeRef.current;
//   html2canvas(input).then((canvas) => {
//     const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();
//     const imgWidth = canvas.width;
//     const imgHeight = canvas.height;
//     const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
//     const imgX = (pdfWidth - imgWidth * ratio) / 2;
//     const imgY = 0;
    
//     pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
//     pdf.save('tailored-resume.pdf');
//   });
// };

// // Function to handle user data changes
// const handleUserDataChange = (field, value) => {
//   setUserData(prevState => ({
//     ...prevState,
//     [field]: value
//   }));
// };

// // Function to handle tabs
// const switchTab = (tab) => {
//   setActiveTab(tab);
// };

// return (
//   <div className="resume-builder-container my-5 py-5">
//     <header className="resume-builder-header">
//       <h1>Smart Resume Builder</h1>
//       <div className="tab-navigation">
//         <button 
//           className={`tab-button ${activeTab === 'generator' ? 'active' : ''}`}
//           onClick={() => switchTab('generator')}
//         >
//           Resume Generator
//         </button>
//         <button 
//           className={`tab-button ${activeTab === 'atsChecker' ? 'active' : ''}`}
//           onClick={() => switchTab('atsChecker')}
//         >
//           ATS Compatibility Checker
//         </button>
//       </div>
//     </header>

//     {activeTab === 'generator' && (
//       <div className="generator-container">
//         <div className="input-section ">
//           <h2>Generate Your Tailored Resume</h2>
//           <p>Enter a job title and description to create a tailored resume that matches the requirements.</p>
          
//           <div className="form-group col-lg-6">
//             <label htmlFor="jobTitle">Job Title:</label>
//             <input 
//               type="text" 
//               id="jobTitle" 
//               value={jobTitle} 
//               onChange={(e) => setJobTitle(e.target.value)} 
//               placeholder="e.g. Front End Developer"
//             />
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="jobDescription">Job Description:</label>
//             <textarea 
//               id="jobDescription" 
//               value={jobDescription} 
//               onChange={(e) => setJobDescription(e.target.value)} 
//               placeholder="Paste the full job description here..."
//               rows={10}
//             />
//           </div>
           
//           <div className="user-data-section col-lg-6 " >
//             <h3>Your Information</h3>
//             <div className="form-row">
//               <div className="form-group">
//                 <label htmlFor="name">Full Name:</label>
//                 <input 
//                   type="text" 
//                   id="name" 
//                   value={userData.name} 
//                   onChange={(e) => handleUserDataChange('name', e.target.value)} 
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="email">Email:</label>
//                 <input 
//                   type="email" 
//                   id="email" 
//                   value={userData.email} 
//                   onChange={(e) => handleUserDataChange('email', e.target.value)} 
//                 />
//               </div>
//             </div>
            
//             <div className="form-row">
//               <div className="form-group">
//                 <label htmlFor="phone">Phone:</label>
//                 <input 
//                   type="text" 
//                   id="phone" 
//                   value={userData.phone} 
//                   onChange={(e) => handleUserDataChange('phone', e.target.value)} 
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="github">GitHub:</label>
//                 <input 
//                   type="text" 
//                   id="github" 
//                   value={userData.github} 
//                   onChange={(e) => handleUserDataChange('github', e.target.value)} 
//                 />
//               </div>
//             </div>
            
//             <div className="form-row">
//               <div className="form-group">
//                 <label htmlFor="linkedin">LinkedIn:</label>
//                 <input 
//                   type="text" 
//                   id="linkedin" 
//                   value={userData.linkedin} 
//                   onChange={(e) => handleUserDataChange('linkedin', e.target.value)} 
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="portfolio">Portfolio:</label>
//                 <input 
//                   type="text" 
//                   id="portfolio" 
//                   value={userData.portfolio} 
//                   onChange={(e) => handleUserDataChange('portfolio', e.target.value)} 
//                 />
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="education">Education:</label>
//               <input 
//                 type="text" 
//                 id="education" 
//                 value={userData.education} 
//                 onChange={(e) => handleUserDataChange('education', e.target.value)} 
//               />
//             </div>
//           </div>
          
//           <button 
//             className="primary-button" 
//             onClick={generateResumeHandler} 
//             disabled={isGenerating}
//           >
//             {isGenerating ? 'Generating...' : 'Generate Resume'}
//           </button>
//         </div>
        
//         {generatedResume && (
//           <div className="resume-preview-section">
//             <div className="resume-actions">
//               <h2>Your Tailored Resume</h2>
//               <button 
//                 className="download-button" 
//                 onClick={downloadResumeAsPdf}
//               >
//                 Download as PDF
//               </button>
//             </div>
            
//             <div className="resume-preview" ref={resumeRef}>
//               <div className="resume-header">
//                 <h1>{userData.name}</h1>
//                 <div className="contact-info">
//                   <p>{userData.email} | {userData.phone}</p>
//                   <p>{userData.github} | {userData.linkedin} | {userData.portfolio}</p>
//                 </div>
//               </div>
              
//               <div className="resume-section">
//                 <h2>Professional Summary</h2>
//                 <p>{generatedResume.summary}</p>
//               </div>
              
//               <div className="resume-section">
//                 <h2>Skills</h2>
//                 <div className="skills-list">
//                   {generatedResume.skills.map((skill, index) => (
//                     <span key={index} className="skill-tag">{skill}</span>
//                   ))}
//                 </div>
//               </div>
              
//               <div className="resume-section">
//                 <h2>Work Experience</h2>
//                 {generatedResume.experience.map((job, index) => (
//                   <div key={index} className="experience-item">
//                     <div className="experience-header">
//                       <h3>{job.title}</h3>
//                       <span className="experience-duration">{job.duration}</span>
//                     </div>
//                     <h4>{job.company}</h4>
//                     <ul>
//                       {job.responsibilities.map((resp, rIndex) => (
//                         <li key={rIndex}>{resp}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 ))}
//               </div>
              
//               <div className="resume-section">
//                 <h2>Projects</h2>
//                 {generatedResume.projects.map((project, index) => (
//                   <div key={index} className="project-item">
//                     <h3>{project.name}</h3>
//                     <p>{project.description}</p>
//                     <p><strong>Technologies:</strong> {project.technologies}</p>
//                   </div>
//                 ))}
//               </div>
              
//               <div className="resume-section">
//                 <h2>Education</h2>
//                 <p>{userData.education}</p>
//               </div>
              
//               {generatedResume.certifications.length > 0 && (
//                 <div className="resume-section">
//                   <h2>Certifications</h2>
//                   <ul className="certification-list">
//                     {generatedResume.certifications.map((cert, index) => (
//                       <li key={index}>{cert}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     )}

//     {activeTab === 'atsChecker' && (
//       <div className="ats-checker-container">
//         <div className="input-section">
//           <h2>ATS Compatibility Checker</h2>
//           <p>Check how well your resume matches a specific job description and get recommendations.</p>
          
//           <div className="form-group">
//             <label htmlFor="uploadedResume">Paste your resume text:</label>
//             <textarea 
//               id="uploadedResume" 
//               value={uploadedResume} 
//               onChange={(e) => setUploadedResume(e.target.value)} 
//               placeholder="Paste the full text content of your resume here..."
//               rows={10}
//             />
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="atsJobDescription">Job Description:</label>
//             <textarea 
//               id="atsJobDescription" 
//               value={atsJobDescription} 
//               onChange={(e) => setAtsJobDescription(e.target.value)} 
//               placeholder="Paste the job description you want to apply for..."
//               rows={10}
//             />
//           </div>
          
//           <button 
//             className="primary-button" 
//             onClick={analyzeResumeHandler} 
//             disabled={isGenerating}
//           >
//             {isGenerating ? 'Analyzing...' : 'Analyze Resume'}
//           </button>
//         </div>
        
//         {atsScore && (
//           <div className="ats-results-section">
//             <h2>ATS Analysis Results</h2>
            
//             <div className="score-section">
//               <div className="score-circle">
//                 <div className="score-number">{atsScore.score}%</div>
//                 <div className="score-label">Match</div>
//               </div>
              
//               <div className="score-feedback">
//                 <h3>Overall Assessment</h3>
//                 <p>{atsScore.feedback}</p>
//               </div>
//             </div>
            
//             <div className="keywords-section">
//               <div className="keywords-matched">
//                 <h3>Matched Keywords</h3>
//                 <div className="keywords-list">
//                   {atsScore.matchedKeywords.map((keyword, index) => (
//                     <span key={index} className="keyword-tag matched">{keyword}</span>
//                   ))}
//                   {atsScore.matchedKeywords.length === 0 && <p>No keywords matched.</p>}
//                 </div>
//               </div>
              
//               <div className="keywords-missing">
//                 <h3>Missing Keywords</h3>
//                 <div className="keywords-list">
//                   {atsScore.missingKeywords.map((keyword, index) => (
//                     <span key={index} className="keyword-tag missing">{keyword}</span>
//                   ))}
//                   {atsScore.missingKeywords.length === 0 && <p>No missing keywords. Great job!</p>}
//                 </div>
//               </div>
//             </div>
            
//             <div className="suggestions-section">
//               <h3>Improvement Suggestions</h3>
//               <ul>
//                 {atsScore.suggestions.map((suggestion, index) => (
//                   <li key={index}>{suggestion}</li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         )}
//       </div>
//     )}
//   </div>
// );
// }

// export default ResumeBuilder1;



import React, { useState, useRef } from 'react';
import { FaUser, FaEnvelope, FaPhone, FaGithub, FaLinkedin, FaGlobe, FaGraduationCap, FaBriefcase, FaTools, FaCertificate, FaProjectDiagram, FaFileDownload, FaEdit, FaPlus, FaTrash, FaCheckCircle, FaTimes } from 'react-icons/fa';
import { Navigate } from 'react-router-dom';

const AIResumeBuilder = () => {
  const [activeTab, setActiveTab] = useState('generator');
  const [prompt, setPrompt] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [resume, setResume] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  
  // ATS Checker states
  const [atsResume, setAtsResume] = useState('');
  const [atsJobDesc, setAtsJobDesc] = useState('');
  const [atsResult, setAtsResult] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  
  const resumeRef = useRef(null);

  // AI Resume Generation Logic
  const generateResume = async () => {
    if (!prompt.trim()) {
      alert('Please enter a job title or description');
      return;
    }

    setIsGenerating(true);
    
    await new Promise(resolve => setTimeout(resolve, 2000));

    const keywords = extractKeywords(prompt);
    const industry = determineIndustry(prompt);
    
    const generatedResume = {
      personalInfo: {
        name: 'John Doe',
        email: 'john.doe@email.com',
        phone: '+1 (555) 123-4567',
        github: 'github.com/johndoe',
        linkedin: 'linkedin.com/in/johndoe',
        portfolio: 'johndoe.dev',
        location: 'New York, NY'
      },
      summary: generateSummary(prompt, keywords, industry),
      skills: generateSkills(keywords, industry),
      experience: generateExperience(prompt, keywords, industry),
      projects: generateProjects(keywords, industry),
      education: generateEducation(industry),
      certifications: generateCertifications(keywords, industry)
    };

    setResume(generatedResume);
    setIsGenerating(false);
  };

  const extractKeywords = (text) => {
    const commonSkills = [
      'JavaScript', 'Python', 'Java', 'React', 'Node.js', 'Angular', 'Vue.js',
      'TypeScript', 'SQL', 'MongoDB', 'AWS', 'Azure', 'Docker', 'Kubernetes',
      'Git', 'Agile', 'Scrum', 'REST API', 'GraphQL', 'CI/CD', 'Machine Learning',
      'Data Analysis', 'Leadership', 'Project Management', 'Communication',
      'Problem Solving', 'Team Collaboration', 'HTML', 'CSS', 'Express.js',
      'Django', 'Flask', 'Spring Boot', 'MySQL', 'PostgreSQL', 'Redis',
      'TensorFlow', 'PyTorch', 'Pandas', 'NumPy', 'Tableau', 'Power BI', 'Rust',
      'WebAssembly', 'Tokio', 'Actix', 'Rocket'
    ];
    
    const found = commonSkills.filter(skill => 
      text.toLowerCase().includes(skill.toLowerCase())
    );
    
    return found.length > 0 ? found : ['JavaScript', 'React', 'Node.js', 'Git', 'Agile'];
  };

  const determineIndustry = (text) => {
    const industries = {
      'Software': ['software', 'developer', 'engineer', 'programmer', 'coding', 'rust', 'full stack'],
      'Data Science': ['data', 'analytics', 'scientist', 'machine learning', 'AI'],
      'Design': ['designer', 'UI', 'UX', 'graphic', 'creative'],
      'Management': ['manager', 'director', 'lead', 'head', 'supervisor'],
      'Marketing': ['marketing', 'social media', 'content', 'SEO', 'brand']
    };

    for (const [industry, keywords] of Object.entries(industries)) {
      if (keywords.some(kw => text.toLowerCase().includes(kw))) {
        return industry;
      }
    }
    return 'Software';
  };

  const generateSummary = (prompt, keywords, industry) => {
    const role = prompt.split(' ').slice(0, 4).join(' ') || 'Software Developer';
    const years = Math.floor(Math.random() * 5) + 3;
    const topSkills = keywords.slice(0, 3).join(', ');
    
    return `Results-driven ${role} with ${years}+ years of experience in ${industry.toLowerCase()}. Expertise in ${topSkills} with a proven track record of delivering high-quality solutions. Strong problem-solving abilities and excellent communication skills. Passionate about leveraging technology to solve complex business challenges and drive innovation.`;
  };

  const generateSkills = (keywords, industry) => {
    const baseSkills = [...keywords];
    const additionalSkills = {
      'Software': ['Responsive Design', 'Testing', 'Debugging', 'Code Review', 'Microservices'],
      'Data Science': ['Statistical Analysis', 'Data Visualization', 'ETL', 'Big Data', 'Predictive Modeling'],
      'Design': ['Figma', 'Adobe XD', 'Sketch', 'Wireframing', 'Prototyping'],
      'Management': ['Strategic Planning', 'Team Building', 'Budgeting', 'Stakeholder Management'],
      'Marketing': ['Content Strategy', 'Campaign Management', 'Analytics', 'A/B Testing']
    };

    return [...new Set([...baseSkills, ...(additionalSkills[industry] || additionalSkills['Software'])])].slice(0, 12);
  };

  const generateExperience = (prompt, keywords, industry) => {
    const currentYear = new Date().getFullYear();
    const role = prompt.split(' ').slice(0, 4).join(' ') || 'Software Developer';
    
    return [
      {
        title: `Senior ${role}`,
        company: 'Tech Innovations Inc.',
        location: 'San Francisco, CA',
        duration: `${currentYear - 2} - Present`,
        responsibilities: [
          `Led development of scalable applications using ${keywords[0] || 'React'} and ${keywords[1] || 'Node.js'}`,
          `Improved system performance by 40% through optimization and code refactoring`,
          `Mentored team of 5 junior developers in best practices and modern development techniques`,
          `Collaborated with cross-functional teams to deliver projects 20% ahead of schedule`,
          `Implemented CI/CD pipelines reducing deployment time by 60%`
        ]
      },
      {
        title: role,
        company: 'Digital Solutions Corp.',
        location: 'New York, NY',
        duration: `${currentYear - 5} - ${currentYear - 2}`,
        responsibilities: [
          `Developed and maintained multiple client-facing applications`,
          `Implemented new features resulting in 30% increase in user engagement`,
          `Worked in Agile environment with 2-week sprint cycles`,
          `Conducted code reviews and provided constructive feedback to team members`,
          `Integrated third-party APIs and services to enhance application functionality`
        ]
      }
    ];
  };

  const generateProjects = (keywords, industry) => {
    return [
      {
        name: 'E-Commerce Platform',
        description: `Built a full-stack e-commerce platform using ${keywords[0] || 'React'}, ${keywords[1] || 'Node.js'}, and ${keywords[2] || 'MongoDB'}. Features include user authentication, product catalog, shopping cart, and payment integration.`,
        technologies: keywords.slice(0, 4).join(', '),
        link: 'github.com/johndoe/ecommerce'
      },
      {
        name: 'Task Management System',
        description: `Developed a collaborative task management application with real-time updates, drag-and-drop functionality, and team collaboration features. Implemented responsive design for mobile and desktop.`,
        technologies: keywords.slice(0, 3).join(', '),
        link: 'github.com/johndoe/taskmanager'
      }
    ];
  };

  const generateEducation = (industry) => {
    return [
      {
        degree: 'Bachelor of Science in Computer Science',
        institution: 'University of Technology',
        year: '2015 - 2019',
        gpa: '3.8/4.0'
      }
    ];
  };

  const generateCertifications = (keywords, industry) => {
    const certs = {
      'Software': ['AWS Certified Solutions Architect', 'Microsoft Certified: Azure Developer', 'Certified Kubernetes Administrator'],
      'Data Science': ['Google Data Analytics Certificate', 'IBM Data Science Professional', 'AWS Certified Machine Learning'],
      'Design': ['Adobe Certified Expert', 'Google UX Design Certificate', 'Certified User Experience Professional'],
      'Management': ['PMP Certification', 'Certified Scrum Master', 'Lean Six Sigma Green Belt'],
      'Marketing': ['Google Ads Certification', 'HubSpot Content Marketing', 'Facebook Blueprint Certification']
    };

    return (certs[industry] || certs['Software']).slice(0, 2);
  };

  // Edit handlers
  const updatePersonalInfo = (field, value) => {
    setResume(prev => ({
      ...prev,
      personalInfo: { ...prev.personalInfo, [field]: value }
    }));
  };

  const updateSummary = (value) => {
    setResume(prev => ({ ...prev, summary: value }));
  };

  const addSkill = () => {
    const skill = prompt('Enter new skill:');
    if (skill) {
      setResume(prev => ({
        ...prev,
        skills: [...prev.skills, skill]
      }));
    }
  };

  const removeSkill = (index) => {
    setResume(prev => ({
      ...prev,
      skills: prev.skills.filter((_, i) => i !== index)
    }));
  };

  const addExperience = () => {
    const newExp = {
      title: 'Job Title',
      company: 'Company Name',
      location: 'Location',
      duration: 'Start - End',
      responsibilities: ['Add responsibilities here']
    };
    setResume(prev => ({
      ...prev,
      experience: [...prev.experience, newExp]
    }));
  };

  const updateExperience = (index, field, value) => {
    setResume(prev => ({
      ...prev,
      experience: prev.experience.map((exp, i) => 
        i === index ? { ...exp, [field]: value } : exp
      )
    }));
  };

  const removeExperience = (index) => {
    setResume(prev => ({
      ...prev,
      experience: prev.experience.filter((_, i) => i !== index)
    }));
  };

  const addProject = () => {
    const newProject = {
      name: 'Project Name',
      description: 'Project description',
      technologies: 'Technologies used',
      link: 'project-link'
    };
    setResume(prev => ({
      ...prev,
      projects: [...prev.projects, newProject]
    }));
  };

  const updateProject = (index, field, value) => {
    setResume(prev => ({
      ...prev,
      projects: prev.projects.map((proj, i) => 
        i === index ? { ...proj, [field]: value } : proj
      )
    }));
  };

  const removeProject = (index) => {
    setResume(prev => ({
      ...prev,
      projects: prev.projects.filter((_, i) => i !== index)
    }));
  };

  // Download as PDF
  const downloadAsPDF = () => {
    const printWindow = window.open('', '', 'height=800,width=800');
    const resumeHTML = resumeRef.current.innerHTML;
    
    printWindow.document.write(`
      <html>
        <head>
          <title>Resume - ${resume.personalInfo.name}</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              margin: 40px;
              color: #333;
            }
            h1 { 
              font-size: 32px; 
              margin-bottom: 10px;
              text-align: center;
            }
            .contact-info { 
              text-align: center; 
              margin-bottom: 20px;
              font-size: 14px;
            }
            .section-title { 
              color: #0d6efd; 
              font-size: 18px; 
              font-weight: bold;
              border-bottom: 2px solid #0d6efd;
              margin-top: 20px;
              margin-bottom: 10px;
              padding-bottom: 5px;
              text-transform: uppercase;
            }
            .skills-container { 
              display: flex; 
              flex-wrap: wrap; 
              gap: 8px;
              margin-bottom: 15px;
            }
            .skill-badge { 
              background: #e9ecef; 
              padding: 5px 12px; 
              border-radius: 4px;
              font-size: 13px;
            }
            .experience-item { 
              margin-bottom: 20px; 
            }
            .experience-header { 
              display: flex; 
              justify-content: space-between;
              margin-bottom: 5px;
            }
            .job-title { 
              font-weight: bold; 
              font-size: 16px;
            }
            .company { 
              color: #666; 
              margin-bottom: 8px;
              font-size: 14px;
            }
            ul { 
              margin: 0; 
              padding-left: 20px;
            }
            li { 
              margin-bottom: 5px;
              font-size: 14px;
              line-height: 1.5;
            }
            .project-item {
              margin-bottom: 15px;
            }
            .project-name {
              font-weight: bold;
              font-size: 15px;
              margin-bottom: 5px;
            }
            p {
              margin: 5px 0;
              font-size: 14px;
              line-height: 1.6;
            }
          </style>
        </head>
        <body>
          ${resumeHTML}
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  // Download as DOCX (plain text format)
  const downloadAsDOCX = () => {
    let content = `${resume.personalInfo.name}\n`;
    content += `${resume.personalInfo.email} | ${resume.personalInfo.phone}\n`;
    content += `${resume.personalInfo.linkedin} | ${resume.personalInfo.github} | ${resume.personalInfo.portfolio}\n\n`;
    content += `PROFESSIONAL SUMMARY\n`;
    content += `${resume.summary}\n\n`;
    content += `SKILLS\n`;
    content += `${resume.skills.join(', ')}\n\n`;
    content += `WORK EXPERIENCE\n\n`;
    resume.experience.forEach(exp => {
      content += `${exp.title}\n`;
      content += `${exp.company} | ${exp.location}\n`;
      content += `${exp.duration}\n`;
      exp.responsibilities.forEach(resp => content += `• ${resp}\n`);
      content += `\n`;
    });
    content += `PROJECTS\n\n`;
    resume.projects.forEach(proj => {
      content += `${proj.name}\n`;
      content += `${proj.description}\n`;
      content += `Technologies: ${proj.technologies}\n\n`;
    });
    content += `EDUCATION\n`;
    resume.education.forEach(edu => {
      content += `${edu.degree}\n`;
      content += `${edu.institution} | ${edu.year} | GPA: ${edu.gpa}\n\n`;
    });
    content += `CERTIFICATIONS\n`;
    resume.certifications.forEach(cert => content += `• ${cert}\n`);
    
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${resume.personalInfo.name.replace(/\s/g, '_')}_Resume.doc`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // ATS Checker
  const analyzeATS = async () => {
    if (!atsResume || !atsJobDesc) {
      alert('Please provide both resume text and job description');
      return;
    }

    setIsAnalyzing(true);
    await new Promise(resolve => setTimeout(resolve, 1500));

    const resumeKeywords = extractKeywordsFromText(atsResume);
    const jobKeywords = extractKeywordsFromText(atsJobDesc);
    
    const matchedKeywords = resumeKeywords.filter(kw => 
      jobKeywords.some(jk => jk.toLowerCase() === kw.toLowerCase())
    );
    
    const score = jobKeywords.length > 0 
      ? Math.round((matchedKeywords.length / jobKeywords.length) * 100) 
      : 0;
    
    const missingKeywords = jobKeywords.filter(jk => 
      !matchedKeywords.some(mk => mk.toLowerCase() === jk.toLowerCase())
    );

    const suggestions = generateSuggestions(score, missingKeywords);

    setAtsResult({
      score,
      matchedKeywords,
      missingKeywords,
      suggestions
    });
    
    setIsAnalyzing(false);
  };

  const extractKeywordsFromText = (text) => {
  const commonSkills = [
  "JavaScript",
  "Python",
  "Java",
  "React",
  "Node.js",
  "Angular",
  "Vue.js",
  "TypeScript",
  "SQL",
  "MongoDB",
  "AWS",
  "Azure",
  "Docker",
  "Kubernetes",
  "Git",
  "Agile",
  "Scrum",
  "REST API",
  "GraphQL",
  "Machine Learning",
  "Leadership",
  "Communication",
  "Problem Solving",
  "Team Collaboration",
  "HTML",
  "CSS",
  "Express.js",
  "Django",
  "Flask",
  "Spring Boot",
  "MySQL",
  "PostgreSQL",
  "Redis",
  "CI/CD",
  "DevOps",
  "Microservices",
  "TDD",
  "Project Management",
  "Data Analysis",
  "Rust",
  "WebAssembly",
  "C",
  "C++",
  "C#",
  "Go",
  "Ruby",
  "PHP",
  "Perl",
  "Scala",
  "Swift",
  "Objective-C",
  "Kotlin",
  "R",
  "MATLAB",
  "Haskell",
  "Lua",
  "Elixir",
  "Erlang",
  "F#",
  "Assembly",
  "Shell",
  "PowerShell",
  "VB.NET",
  "D",
  "Fortran",
  "COBOL",
  "Pascal",
  "Sass",
  "Less",
  "Bootstrap",
  "Tailwind CSS",
  "Material-UI",
  "Ant Design",
  "Semantic UI",
  "Styled Components",
  "Emotion",
  "Next.js",
  "Gatsby",
  "Nuxt.js",
  "Svelte",
  "SvelteKit",
  "Elm",
  "Alpine.js",
  "Backbone.js",
  "jQuery",
  "Webpack",
  "Parcel",
  "Rollup",
  "Vite",
  "Babel",
  "Pug",
  "Handlebars",
  "Three.js",
  "D3.js",
  "Chart.js",
  "Highcharts",
  "Laravel",
  "Symfony",
  "ASP.NET Core",
  "FastAPI",
  "Hapi.js",
  "NestJS",
  "Koa",
  "Play Framework",
  "Micronaut",
  "Vert.x",
  "Hibernate",
  "ORM",
  "SQLAlchemy",
  "Peewee",
  "Liquibase",
  "Flyway",
  "gRPC",
  "Thrift",
  "SOAP",
  "SQLite",
  "MariaDB",
  "Oracle",
  "Cassandra",
  "CouchDB",
  "Couchbase",
  "Neo4j",
  "InfluxDB",
  "TimescaleDB",
  "DynamoDB",
  "HBase",
  "RethinkDB",
  "Amazon Aurora",
  "Memcached",
  "Elasticsearch",
  "Logstash",
  "Kibana",
  "Opensearch",
  "Google Cloud Platform",
  "GCP",
  "IBM Cloud",
  "Heroku",
  "DigitalOcean",
  "Linode",
  "Oracle Cloud",
  "Cloudflare",
  "Firebase",
  "AWS Lambda",
  "Azure Functions",
  "Serverless",
  "CloudFormation",
  "Terraform",
  "Pulumi",
  "Ansible",
  "Chef",
  "Puppet",
  "Jenkins",
  "CircleCI",
  "Travis CI",
  "GitLab CI",
  "Azure DevOps",
  "Argo CD",
  "Flux",
  "Prometheus",
  "Grafana",
  "ELK Stack",
  "Datadog",
  "New Relic",
  "Splunk",
  "PagerDuty",
  "Sentry",
  "Istio",
  "Linkerd",
  "Consul",
  "Nomad",
  "Podman",
  "CRI-O",
  "Containerd",
  "Helm",
  "Kustomize",
  "OpenShift",
  "OAuth2",
  "OpenID Connect",
  "JWT",
  "SAML",
  "TLS/SSL",
  "Encryption",
  "Hashing",
  "OWASP",
  "WAF",
  "Penetration Testing",
  "SIEM",
  "IAM",
  "Vault",
  "Keycloak",
  "Lets Encrypt",
  "AppArmor",
  "SELinux",
  "Jest",
  "Mocha",
  "Chai",
  "Jasmine",
  "Cypress",
  "Selenium",
  "Puppeteer",
  "Playwright",
  "Enzyme",
  "React Testing Library",
  "JUnit",
  "TestNG",
  "PyTest",
  "RSpec",
  "Karma",
  "Sinon",
  "Mockito",
  "REST Assured",
  "Postman",
  "Newman",
  "LoadRunner",
  "Gatling",
  "Pandas",
  "NumPy",
  "SciPy",
  "Scikit-learn",
  "TensorFlow",
  "PyTorch",
  "Keras",
  "XGBoost",
  "LightGBM",
  "CatBoost",
  "OpenCV",
  "NLTK",
  "spaCy",
  "Hugging Face",
  "MLflow",
  "Kubeflow",
  "BigQuery",
  "Hadoop",
  "Spark",
  "Flink",
  "Kafka",
  "Airflow",
  "Beam",
  "Presto",
  "Android",
  "iOS",
  "React Native",
  "Flutter",
  "Ionic",
  "Cordova",
  "SwiftUI",
  "Jetpack Compose",
  "Xamarin",
  "Kotlin Multiplatform",
  "TCP/IP",
  "UDP",
  "HTTP",
  "HTTPS",
  "WebSockets",
  "MQTT",
  "AMQP",
  "gRPC",
  "RESTful Design",
  "DNS",
  "CDN",
  "Load Balancing",
  "NAT",
  "VPN",
  "BGP",
  "OSPF",
  "SOA",
  "Event-Driven Architecture",
  "CQRS",
  "Event Sourcing",
  "Hexagonal Architecture",
  "Layered Architecture",
  "Clean Architecture",
  "Monolith",
  "Serverless Architecture",
  "Distributed Systems",
  "CAP Theorem",
  "High Availability",
  "Scalability",
  "Fault Tolerance",
  "Figma",
  "Sketch",
  "Adobe XD",
  "InVision",
  "Zeplin",
  "Accessibility",
  "WCAG",
  "Usability Testing",
  "User Research",
  "A/B Testing",
  "Interaction Design",
  "Information Architecture",
  "Blockchain",
  "Ethereum",
  "Solidity",
  "Hyperledger",
  "Smart Contracts",
  "IPFS",
  "Cryptography",
  "Bitcoin",
  "DeFi",
  "NFTs",
  "Edge Computing",
  "IoT",
  "Raspberry Pi",
  "Arduino",
  "Robotics",
  "Embedded Systems",
  "Computer Vision",
  "Augmented Reality",
  "Virtual Reality",
  "Game Development",
  "Unity",
  "Unreal Engine",
  "Blender",
  "Design Systems",
  "Graph Databases",
  "Data Warehousing",
  "ETL",
  "SSIS",
  "Talend",
  "Pentaho",
  "Business Intelligence",
  "Tableau",
  "Power BI",
  "Looker",
  "Time Management",
  "Critical Thinking",
  "Negotiation",
  "Presentation",
  "Mentoring",
  "Coaching",
  "Hiring",
  "Recruitment",
  "Budgeting",
  "Stakeholder Management",
  "Product Management",
  "Roadmapping",
  "Prioritization",
  "JSON",
  "XML",
  "YAML",
  "Protocol Buffers",
  "Avro",
  "Parquet",
  "ORC",
  "CSV",
  "MessagePack",
  "AWS S3",
  "AWS EC2",
  "AWS RDS",
  "AWS DynamoDB",
  "AWS ECS",
  "AWS EKS",
  "AWS CloudWatch",
  "AWS IAM",
  "AWS CloudFront",
  "AWS SNS",
  "AWS SQS",
  "AWS Route 53",
  "Azure Blob Storage",
  "Azure SQL Database",
  "Azure Cosmos DB",
  "Azure AD",
  "Azure DevOps Services",
  "GCP Compute Engine",
  "GCP Cloud Storage",
  "GCP Bigtable",
  "GCP Pub/Sub",
  "GCP Cloud Functions",
  "Firebase Realtime Database",
  "Firebase Firestore",
  "Firebase Auth",
  "Heroku Dynos",
  "DigitalOcean Droplets",
  "Kubernetes Operators",
  "Serverless Framework",
  "Edge Functions",
  "Cloud Run",
  "Cloud Build",
  "Azure Functions Proxies",
  "AWS Lambda@Edge",
  "Terraform Cloud",
  "Terraform Enterprise",
  "Pulumi Crosswalk",
  "Redis Streams",
  "Redis Cluster",
  "Redis Sentinel",
  "Amazon Aurora Serverless",
  "Aurora Global Database",
  "Oracle RAC",
  "Oracle PL/SQL",
  "SQL Window Functions",
  "ACID Transactions",
  "MVCC",
  "Continuous Delivery",
  "Continuous Deployment",
  "Blue-Green Deployment",
  "Canary Releases",
  "Feature Flags",
  "LaunchDarkly",
  "Istio Service Mesh",
  "Linkerd Service Mesh",
  "Envoy Proxy",
  "gRPC-Web",
  "GraphQL Federation",
  "OpenTelemetry",
  "Distributed Tracing",
  "Jaeger",
  "Zipkin",
  "Service Discovery",
  "Health Checks",
  "Circuit Breaker",
  "Bulkhead Pattern",
  "Backpressure",
  "Rate Limiting",
  "OAuth 1.0",
  "PKI",
  "HSM",
  "FIDO2",
  "WebAuthn",
  "Security Auditing",
  "Dependency Scanning",
  "Static Application Security Testing",
  "Dynamic Application Security Testing",
  "Container Security",
  "Image Scanning",
  "Notary",
  "SBOM",
  "Supply Chain Security",
  "SCA (Software Composition Analysis)",
  "Threat Modeling",
  "Mobile CI/CD",
  "App Store Connect",
  "Google Play Console",
  "In-App Purchases",
  "Push Notifications",
  "FCM",
  "APNs",
  "Deep Linking",
  "Universal Links",
  "WebRTC",
  "Media Streaming",
  "HLS",
  "DASH",
  "FFmpeg",
  "Transcoding",
  "Adaptive Bitrate Streaming",
  "Protocol Design",
  "REST Best Practices",
  "Idempotency",
  "ETags",
  "Caching Strategies",
  "Cache Invalidation",
  "CDN Caching",
  "Immutable Assets",
  "Data Modeling",
  "Dimensional Modeling",
  "Star Schema",
  "Snowflake Schema",
  "Slowly Changing Dimensions",
  "CDC (Change Data Capture)",
  "Debezium",
  "OLAP",
  "OLTP",
  "Columnar Storage",
  "Row Storage",
  "Compression Techniques",
  "Bloom Filters",
  "B-Tree",
  "LSM Tree",
  "ACID vs BASE",
  "Cloud Native"
]

    
    return commonSkills.filter(skill => 
      text.toLowerCase().includes(skill.toLowerCase())
    );
  };

  const generateSuggestions = (score, missing) => {
    const suggestions = [];
    
    if (score < 50) {
      suggestions.push('Your resume needs significant improvements to match this job');
      suggestions.push('Consider restructuring your resume to highlight relevant experience');
      suggestions.push('Add more industry-specific keywords from the job description');
    } else if (score < 75) {
      suggestions.push('Good match, but there\'s room for improvement');
      suggestions.push('Add more specific examples of your achievements');
      suggestions.push('Quantify your accomplishments with metrics and results');
    } else {
      suggestions.push('Excellent match! Your resume aligns well with the job');
      suggestions.push('Consider adding quantifiable metrics to strengthen your application');
    }
    
    if (missing.length > 0) {
      suggestions.push(`Consider adding: ${missing.slice(0, 5).join(', ')}`);
    }
    
    suggestions.push('Use action verbs to describe your accomplishments');
    suggestions.push('Ensure your formatting is ATS-friendly (avoid tables and graphics)');
    suggestions.push('Include relevant certifications if you have them');
    
    return suggestions;
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f5f7fa' }}>
      {/* Header Navigation */}
   
      <div className="container my-5 py-5">
        {/* Tab Navigation */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-body p-0">
                <div className="d-flex">
                  <button 
                    className={`btn btn-lg flex-fill rounded-5 ${activeTab === 'generator' ? 'btn-dark' : 'btn-light text-dark'}`}
                    style={{ borderBottom: activeTab === 'generator' ? '3px solid #033176ff' : 'none' }}
                    onClick={() => setActiveTab('generator')}
                  >
                    <FaBriefcase className="me-2" />
                    Resume Generator
                  </button>
                  <button 
                    className={`btn btn-lg flex-fill rounded-5 ${activeTab === 'ats' ? 'btn-primary' : 'btn-light text-dark'}`}
                    style={{ borderBottom: activeTab === 'ats' ? '3px solid #007b0cff' : 'none' }}
                    onClick={() => setActiveTab('ats')}
                  >
                    <FaCheckCircle className="me-2" />
                    ATS Checker
                  </button>
               
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Resume Generator Tab */}
        {activeTab === 'generator' && (
          <div className="row">
            <div className="col-lg-5 mb-2">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body">
                  <h4 className="card-title fw-bold mb-3">Generate Resume</h4>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Job Title or Description</label>
                    <textarea
                      className="form-control"
                      rows="12"
                      placeholder="Enter job title (e.g., 'Full Stack Developer') or paste full job description..."
                      value={prompt}
                      onChange={(e) => setPrompt(e.target.value)}
                      style={{ fontSize: '14px' }}
                    />
                    <small className="text-muted">
                      💡 Tip: Paste the full job description for better results
                    </small>
                  </div>
                  <button 
                    className="btn btn-primary w-100 py-3 fw-semibold"
                    onClick={generateResume}
                    disabled={isGenerating}
                  >
                    {isGenerating ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Generating Resume...
                      </>
                    ) : (
                      <>
                        <FaBriefcase className="me-2" />
                        Generate Resume
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              {resume ? (
                <>
                  <div className="card shadow-sm border-0 mb-3">
                    <div className="card-body py-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <h5 className="mb-0 fw-bold">Your Resume</h5>
                        <div className="btn-group">
                          <button 
                            className="btn btn-outline-primary"
                            onClick={() => setIsEditing(!isEditing)}
                          >
                            <FaEdit className="me-1" />
                            {isEditing ? 'Done' : 'Edit'}
                          </button>
                          <button 
                            className="btn btn-success"
                            onClick={downloadAsPDF}
                          >
                            <FaFileDownload className="me-1" />
                            PDF
                          </button>
                          <button 
                            className="btn btn-info"
                            onClick={downloadAsDOCX}
                          >
                            <FaFileDownload className="me-1" />
                            TXT
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card shadow-sm border-0" style={{ maxHeight: '800px', overflowY: 'auto' }}>
                    <div className="card-body p-5 bg-white" ref={resumeRef}>
                      {/* Header */}
                      <div className="text-center mb-4 pb-4 border-bottom">
                        {isEditing ? (
                          <>
                            <input 
                              type="text"
                              className="form-control form-control-lg text-center fw-bold mb-2"
                              value={resume.personalInfo.name}
                              onChange={(e) => updatePersonalInfo('name', e.target.value)}
                            />
                            <div className="row g-2 mb-2">
                              <div className="col-md-6">
                                <input 
                                  type="email"
                                  className="form-control form-control-sm"
                                  value={resume.personalInfo.email}
                                  onChange={(e) => updatePersonalInfo('email', e.target.value)}
                                  placeholder="Email"
                                />
                              </div>
                              <div className="col-md-6">
                                <input 
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={resume.personalInfo.phone}
                                  onChange={(e) => updatePersonalInfo('phone', e.target.value)}
                                  placeholder="Phone"
                                />
                              </div>
                            </div>
                            <div className="row g-2">
                              <div className="col-md-4">
                                <input 
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={resume.personalInfo.linkedin}
                                  onChange={(e) => updatePersonalInfo('linkedin', e.target.value)}
                                  placeholder="LinkedIn"
                                />
                              </div>
                              <div className="col-md-4">
                                <input 
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={resume.personalInfo.github}
                                  onChange={(e) => updatePersonalInfo('github', e.target.value)}
                                  placeholder="GitHub"
                                />
                              </div>
                              <div className="col-md-4">
                                <input 
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={resume.personalInfo.portfolio}
                                  onChange={(e) => updatePersonalInfo('portfolio', e.target.value)}
                                  placeholder="Portfolio"
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <h1 className="fw-bold mb-3" style={{ fontSize: '32px' }}>{resume.personalInfo.name}</h1>
                            <div className="contact-info" style={{ fontSize: '14px', color: '#666' }}>
                              <div className="mb-2">
                                <FaEnvelope className="me-2" />{resume.personalInfo.email}
                                <span className="mx-3">|</span>
                                <FaPhone className="me-2" />{resume.personalInfo.phone}
                              </div>
                              <div>
                                <FaLinkedin className="me-2" />{resume.personalInfo.linkedin}
                                <span className="mx-3">|</span>
                                <FaGithub className="me-2" />{resume.personalInfo.github}
                                <span className="mx-3">|</span>
                                <FaGlobe className="me-2" />{resume.personalInfo.portfolio}
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      {/* Professional Summary */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '18px', borderBottom: '2px solid #0d6efd', paddingBottom: '8px' }}>
                          PROFESSIONAL SUMMARY
                        </h2>
                        {isEditing ? (
                          <textarea
                            className="form-control"
                            rows="4"
                            value={resume.summary}
                            onChange={(e) => updateSummary(e.target.value)}
                          />
                        ) : (
                          <p style={{ fontSize: '14px', lineHeight: '1.8', color: '#555', textAlign: 'justify' }}>
                            {resume.summary}
                          </p>
                        )}
                      </div>

                      {/* Skills */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '18px', borderBottom: '2px solid #0d6efd', paddingBottom: '8px' }}>
                          SKILLS
                          {isEditing && (
                            <button className="btn btn-sm btn-success ms-3" onClick={addSkill}>
                              <FaPlus className="me-1" /> Add Skill
                            </button>
                          )}
                        </h2>
                        <div className="skills-container d-flex flex-wrap gap-2">
                          {resume.skills.map((skill, idx) => (
                            <span 
                              key={idx} 
                              className="badge skill-badge px-3 py-2"
                              style={{ 
                                backgroundColor: '#e9ecef', 
                                color: '#333',
                                fontSize: '13px',
                                fontWeight: '500'
                              }}
                            >
                              {skill}
                              {isEditing && (
                                <FaTimes 
                                  className="ms-2 text-danger" 
                                  style={{ cursor: 'pointer', fontSize: '11px' }}
                                  onClick={() => removeSkill(idx)}
                                />
                              )}
                            </span>
                          ))}
                        </div>
                      </div>

                      {/* Work Experience */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '18px', borderBottom: '2px solid #0d6efd', paddingBottom: '8px' }}>
                          WORK EXPERIENCE
                          {isEditing && (
                            <button className="btn btn-sm btn-success ms-3" onClick={addExperience}>
                              <FaPlus className="me-1" /> Add Experience
                            </button>
                          )}
                        </h2>
                        {resume.experience.map((exp, idx) => (
                          <div key={idx} className="experience-item mb-4">
                            {isEditing ? (
                              <>
                                <div className="row g-2 mb-2">
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={exp.title}
                                      onChange={(e) => updateExperience(idx, 'title', e.target.value)}
                                      placeholder="Job Title"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={exp.duration}
                                      onChange={(e) => updateExperience(idx, 'duration', e.target.value)}
                                      placeholder="Duration"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={exp.company}
                                      onChange={(e) => updateExperience(idx, 'company', e.target.value)}
                                      placeholder="Company"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={exp.location}
                                      onChange={(e) => updateExperience(idx, 'location', e.target.value)}
                                      placeholder="Location"
                                    />
                                  </div>
                                </div>
                                <button 
                                  className="btn btn-sm btn-danger"
                                  onClick={() => removeExperience(idx)}
                                >
                                  <FaTrash className="me-1" /> Remove
                                </button>
                              </>
                            ) : (
                              <>
                                <div className="experience-header d-flex justify-content-between align-items-start mb-2">
                                  <h3 className="job-title fw-bold mb-0" style={{ fontSize: '16px', color: '#222' }}>
                                    {exp.title}
                                  </h3>
                                  <span style={{ fontSize: '14px', color: '#666', whiteSpace: 'nowrap' }}>
                                    {exp.duration}
                                  </span>
                                </div>
                                <p className="company mb-3" style={{ fontSize: '14px', color: '#666' }}>
                                  {exp.company} | {exp.location}
                                </p>
                              </>
                            )}
                            <ul style={{ paddingLeft: '20px', margin: 0 }}>
                              {exp.responsibilities.map((resp, rIdx) => (
                                <li key={rIdx} style={{ fontSize: '14px', color: '#555', marginBottom: '8px', lineHeight: '1.6' }}>
                                  {resp}
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>

                      {/* Projects */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '18px', borderBottom: '2px solid #0d6efd', paddingBottom: '8px' }}>
                          PROJECTS
                          {isEditing && (
                            <button className="btn btn-sm btn-success ms-3" onClick={addProject}>
                              <FaPlus className="me-1" /> Add Project
                            </button>
                          )}
                        </h2>
                        {resume.projects.map((proj, idx) => (
                          <div key={idx} className="project-item mb-3">
                            {isEditing ? (
                              <>
                                <input
                                  type="text"
                                  className="form-control form-control-sm mb-2"
                                  value={proj.name}
                                  onChange={(e) => updateProject(idx, 'name', e.target.value)}
                                  placeholder="Project Name"
                                />
                                <textarea
                                  className="form-control form-control-sm mb-2"
                                  rows="3"
                                  value={proj.description}
                                  onChange={(e) => updateProject(idx, 'description', e.target.value)}
                                  placeholder="Description"
                                />
                                <input
                                  type="text"
                                  className="form-control form-control-sm mb-2"
                                  value={proj.technologies}
                                  onChange={(e) => updateProject(idx, 'technologies', e.target.value)}
                                  placeholder="Technologies"
                                />
                                <button 
                                  className="btn btn-sm btn-danger"
                                  onClick={() => removeProject(idx)}
                                >
                                  <FaTrash className="me-1" /> Remove
                                </button>
                              </>
                            ) : (
                              <>
                                <h3 className="project-name fw-bold mb-2" style={{ fontSize: '15px', color: '#222' }}>
                                  {proj.name}
                                </h3>
                                <p style={{ fontSize: '14px', color: '#555', marginBottom: '8px', lineHeight: '1.6', textAlign: 'justify' }}>
                                  {proj.description}
                                </p>
                                <p style={{ fontSize: '14px', color: '#666', margin: 0 }}>
                                  <strong>Technologies:</strong> {proj.technologies}
                                </p>
                              </>
                            )}
                          </div>
                        ))}
                      </div>

                      {/* Education */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '18px', borderBottom: '2px solid #0d6efd', paddingBottom: '8px' }}>
                          EDUCATION
                        </h2>
                        {resume.education.map((edu, idx) => (
                          <div key={idx}>
                            <h3 className="fw-bold mb-1" style={{ fontSize: '15px', color: '#222' }}>
                              {edu.degree}
                            </h3>
                            <p style={{ fontSize: '14px', color: '#666', margin: 0 }}>
                              {edu.institution} | {edu.year} | GPA: {edu.gpa}
                            </p>
                          </div>
                        ))}
                      </div>

                      {/* Certifications */}
                      {resume.certifications.length > 0 && (
                        <div>
                          <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '18px', borderBottom: '2px solid #0d6efd', paddingBottom: '8px' }}>
                            CERTIFICATIONS
                          </h2>
                          <ul style={{ paddingLeft: '20px', margin: 0 }}>
                            {resume.certifications.map((cert, idx) => (
                              <li key={idx} style={{ fontSize: '14px', color: '#555', marginBottom: '8px' }}>
                                {cert}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className="card shadow-sm border-0">
                  <div className="card-body text-center py-5">
                    <FaBriefcase size={64} className="text-muted mb-3" />
                    <h5 className="text-muted">No resume generated yet</h5>
                    <p className="text-muted">Enter a job description and click "Generate Resume"</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* ATS Checker Tab */}
        {activeTab === 'ats' && (
          <div className="row">
            <div className="col-lg-6 mb-2">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body">
                  <h4 className="card-title fw-bold mb-2">
                    <FaCheckCircle className="me-2 text-primary" />
                    ATS Compatibility Checker
                  </h4>
                  <p className="text-muted mb-2">
                    Check how well your resume matches a job description and get improvement suggestions.
                  </p>
                  
                  <div className="mb-2">
                    <label className="form-label fw-semibold">Your Resume Text</label>
                    <textarea
                      className="form-control"
                      rows="10"
                      placeholder="Paste your complete resume content here..."
                      value={atsResume}
                      onChange={(e) => setAtsResume(e.target.value)}
                      style={{ fontSize: '14px' }}
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label className="form-label fw-semibold">Job Description</label>
                    <textarea
                      className="form-control"
                      rows="10"
                      placeholder="Paste the complete job description here..."
                      value={atsJobDesc}
                      onChange={(e) => setAtsJobDesc(e.target.value)}
                      style={{ fontSize: '14px' }}
                    />
                  </div>
                  
                  <button 
                    className="btn btn-primary w-100 py-3 fw-semibold"
                    onClick={analyzeATS}
                    disabled={isAnalyzing}
                  >
                    {isAnalyzing ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Analyzing...
                      </>
                    ) : (
                      <>
                        <FaCheckCircle className="me-2" />
                        Analyze ATS Score
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              {atsResult ? (
                <div className="card shadow-sm border-0">
                  <div className="card-body p-4 ">
                    <h4 className="card-title fw-bold mb-4">
                      <FaCheckCircle className="me-2 text-success" />
                      ATS Analysis Results
                    </h4>
                    
                    {/* Score Display */}
                    <div className="text-center mb-5 py-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                      <div 
                        className="d-inline-flex justify-content-center align-items-center rounded-circle shadow-lg mb-3"
                        style={{
                          width: '160px',
                          height: '160px',
                          background: atsResult.score >= 75 
                            ? 'linear-gradient(135deg, #28a745 0%, #20c997 100%)' 
                            : atsResult.score >= 50 
                              ? 'linear-gradient(135deg, #ffc107 0%, #fd7e14 100%)' 
                              : 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                          color: 'white'
                        }}
                      >
                        <div>
                          <div style={{ fontSize: '48px', fontWeight: '700', lineHeight: '1' }}>
                            {atsResult.score}%
                          </div>
                          <div style={{ fontSize: '16px', fontWeight: '500', marginTop: '8px' }}>
                            Match Score
                          </div>
                        </div>
                      </div>
                      
                      <div className="mt-3">
                        <span 
                          className={`badge px-4 py-2 ${
                            atsResult.score >= 75 ? 'bg-success' : 
                            atsResult.score >= 50 ? 'bg-warning text-dark' : 
                            'bg-danger'
                          }`}
                          style={{ fontSize: '14px' }}
                        >
                          {atsResult.score >= 75 ? '🎉 Excellent Match' : 
                           atsResult.score >= 50 ? '⚠️ Good Match - Needs Improvement' : 
                           '❌ Poor Match - Major Improvements Needed'}
                        </span>
                      </div>
                    </div>

                    {/* Matched Keywords */}
                    <div className="mb-4 p-3" style={{ backgroundColor: '#d1e7dd', borderRadius: '8px', border: '1px solid #badbcc' }}>
                      <h6 className="fw-bold text-success mb-3 d-flex align-items-center">
                        <FaCheckCircle className="me-2" size={20} />
                        Matched Keywords ({atsResult.matchedKeywords.length})
                      </h6>
                      {atsResult.matchedKeywords.length > 0 ? (
                        <div className="d-flex flex-wrap gap-2">
                          {atsResult.matchedKeywords.map((kw, idx) => (
                            <span 
                              key={idx} 
                              className="badge bg-success px-3 py-2"
                              style={{ fontSize: '13px', fontWeight: '500' }}
                            >
                              ✓ {kw}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted mb-0 small">No matching keywords found</p>
                      )}
                    </div>

                    {/* Missing Keywords */}
                    <div className="mb-4 p-3" style={{ backgroundColor: '#f8d7da', borderRadius: '8px', border: '1px solid #f5c2c7' }}>
                      <h6 className="fw-bold text-danger mb-3 d-flex align-items-center">
                        <FaTimes className="me-2" size={20} />
                        Missing Keywords ({atsResult.missingKeywords.length})
                      </h6>
                      {atsResult.missingKeywords.length > 0 ? (
                        <div className="d-flex flex-wrap gap-2">
                          {atsResult.missingKeywords.slice(0, 15).map((kw, idx) => (
                            <span 
                              key={idx} 
                              className="badge bg-danger px-3 py-2"
                              style={{ fontSize: '13px', fontWeight: '500' }}
                            >
                              ✗ {kw}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted mb-0 small">Great! No missing keywords</p>
                      )}
                    </div>

                    {/* Suggestions */}
                    <div className="p-3" style={{ backgroundColor: '#cfe2ff', borderRadius: '8px', border: '1px solid #b6d4fe' }}>
                      <h6 className="fw-bold text-primary mb-3 d-flex align-items-center">
                        <FaTools className="me-2" size={20} />
                        Improvement Suggestions
                      </h6>
                      <ul className="mb-0" style={{ paddingLeft: '20px' }}>
                        {atsResult.suggestions.map((suggestion, idx) => (
                          <li key={idx} className="mb-2" style={{ fontSize: '14px', color: '#004085', lineHeight: '1.6' }}>
                            {suggestion}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Action Buttons */}
                    <div className="mt-4 d-grid gap-2">
                      <button 
                        className="btn btn-outline-primary"
                        onClick={() => {
                          setAtsResult(null);
                          setAtsResume('');
                          setAtsJobDesc('');
                        }}
                      >
                        <FaTools className="me-2" />
                        Check Another Resume
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="card shadow-sm border-0">
                  <div className="card-body text-center py-5">
                    <div 
                      className="d-inline-flex justify-content-center align-items-center rounded-circle mb-4"
                      style={{
                        width: '100px',
                        height: '100px',
                        backgroundColor: '#e9ecef'
                      }}
                    >
                      <FaCheckCircle size={50} className="text-muted" />
                    </div>
                    <h5 className="text-muted mb-3">No Analysis Yet</h5>
                    <p className="text-muted mb-0">
                      Paste your resume and job description, then click "Analyze ATS Score" to see results
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Custom Styles */}
      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          .card-body[ref] * {
            visibility: visible;
          }
          .card-body[ref] {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        
        .form-control:focus {
          border-color: #0d6efd;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15);
        }
        
        .btn {
          transition: all 0.3s ease;
        }
        
        .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
        
        .card {
          transition: all 0.3s ease;
          border-radius: 12px;
        }
        
        .card:hover {
          box-shadow: 0 8px 24px rgba(0,0,0,0.12);
        }
        
        .badge {
          transition: all 0.2s ease;
        }
        
        .badge:hover {
          transform: scale(1.05);
        }
        
        .navbar {
          backdrop-filter: blur(10px);
        }
        
        .section-title {
          letter-spacing: 0.5px;
        }
        
        .experience-item:last-child {
          margin-bottom: 0 !important;
        }
        
        .project-item:last-child {
          margin-bottom: 0 !important;
        }
        
        ::-webkit-scrollbar {
          width: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        
        ::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      `}</style>
    </div>
  );
};

export default AIResumeBuilder;